// MAIN DATA COLLECTION MODULE
//
//import * as Posenet from '@tensorflow-models/posenet';
import * as tf from '@tensorflow/tfjs';
import { ContactSupportOutlined, ControlPointDuplicateOutlined, CropSquareSharp, Forward10, KeyboardReturnRounded, LocalConvenienceStoreOutlined, MoveToInboxRounded, PostAddRounded } from "@material-ui/icons";
import { getDefenderImage } from "../util/defender";
import { guiState, 
		 loadStaticImage,
		 analyzeImage } from "../util/aiMain";
import { initTables,
		 calcMoveVector,
		 calcDistance,
		 calcPixelDistance,
		 calcSpeed,
		 calcDegree,
		 calcFeet2Pixel,
		 calcPixel2Feet,
         calcBodyY,     // use position Y alone
		 birdseyeY,
		 calcYScale,
		 loadImage,
		 FEMUR,			// Y hash
		 SHIST,			// slope histogram
		 formatTimestamp,
         setFrameEvent,
		 calcPixelRatio,
		 calcDirection,
         calcPixel2Meter,
         calcPixel2Femur,
         calcMeter2Pixel,
         calcBodyDY,    // use top & bot DY
		 storeFemurData,
		 setFemurLength,
		 determineDirectionChange,
		 initTest,
		 timeDelta,
		 analyzeHistogram,
         arrayToknAscSort,
         arrayLengthDesSort,
         arrayTimeAscSort,
		 DIR,
         NOW,
		 getDegree } from "../util/util";
import { setupVideoFile,
	 	 playAudio,
         stopVideo,
       } from '../util/videoUtil';
import { HISTORY,
		 CONSTS,
		 STATS,
		 INFO,
		 CONES,
		 TIMES,
		 PTURNS,
		 BTURNS,
		 REACT_STATES,
		 initHistory,
		 CloneObject, 
         initCONES,
		 TURNS} from '../util/object'
import { setFakeCones,
		 selectCalibrationCone,
         checkSessionCalibration,
		 processCalibration,
		 calcPracticeRep,
		 recheckGoal,
		 finishRun,
         compressTurns,
         processPerformance } from './performance';
import { isValidDtype } from '@tensorflow/tfjs-core/dist/util_base';
import { displayFrameTimestamp,
         displayNotification,
		 displayBodyFTS,
		 displaySpeedRibbon,
		 displayBallTouch,
		 displayRepsLeft,
         displayStars,
		 displayTPM,
		 displayCenterDot,
		 displayLengthCalibration,
		 displayText,
		 displayBox,
		 displayBlock,
		 displayImage,
		 displayEllipse,
		 displayExtractedBallBox,
         displayGridLines,
         displayDegrees,
         displayMotionMarkers,
         displayMotionSkeleton,
         displayCalibrationBar,
		 displayPoseTurn,
         displayBodyRatio,
		 displayBodyReverse,
		 displayFacing,
		 displayFilename,
		 timerDisplayResult,
         } from '../util/annotate'
import { ConeObj, FrameHistoryObj } from "../util/template";
import { showDefender } from '../util/defender'
import { process3DSignals,
         calc3DMotionAngles,
         detectStaticMarker,
         analyzeMotionMarkers } from '../util/limbs'


const MIN_HIDX = 10;        // don't trigger too early
const GESTURE_COOL_OFF_MSEC = 500;    // throttle when next gesture can be detected



// central dispatcher of analysis of all types on this frame
//
export function performFrameAnalysis() {
        var hidx = HISTORY.length - 1;
        if (INFO.last_analysis_hidx === hidx) { return };       // no new frame

        var canvas1 = document.getElementById(INFO.analysis_canvas);
		if (canvas1 == null) { return }
        var ctx1 = canvas1.getContext('2d');
        ctx1.width = parseInt(INFO.image_width);
        ctx1.height = parseInt(INFO.image_height);

        analyzeBall(canvas1);
        analyzeBody(canvas1);

		processCalibration();			// setup calibration (if needed)
        processCones(canvas1);          // determine valid cones b4 calibrate, or create fake oens
        checkSessionCalibration(canvas1);      // use cones to do distance calibration

        // KLUDGE: NEED TO OPTIMIZE THIS!
        var canvas2 = document.getElementById("defender");
        if (canvas2){
            var ctx2 = canvas2.getContext('2d');
            ctx2.width = parseInt(INFO.image_width);
            ctx2.height = parseInt(INFO.image_height);
            canvas2.setAttribute("width", INFO.image_width);
            canvas2.setAttribute("height", INFO.image_height);
            showDefender(canvas2);      // Note: break this up to processDefender() and showDefender()?
        }

        processDrillReps();     // will process only if a flip is detected
		processPerformance(canvas1);	// manage run details

        processAnnotation();
        INFO.last_analysis_hidx = hidx;

        // TODO REFACTOR:  colllect annotation display codes together and run at the end
}


const MIN_POSE_USABLE_SCORE = 75;      // determine if a pose is good

// capture pose data into frame for later analysis
//      - extract player position
//      - extract player position from keypoints3D[] if avail
//
var Phip = 1, Phead = 0, Ptop = 0, Peye = 0;
var Pctr_x = 0, Pctr_y = 0, Pctr_by;
// ref: blazePose keypoints: https://github.com/tensorflow/tfjs-models/blob/master/pose-detection/README.md#example-code-and-demos
// ref_code: https://github.com/tensorflow/tfjs-models/tree/master/pose-detection/demos
export function storePoseData(timestamp, pose, canvas_height) {
	var y_position, y_ratio;
	var no_pose = true;
	var hidx = HISTORY.length - 1;
	var hidx1 = nextValidPoseFrame(hidx);		// previous valid frame
	var fdata = CloneObject(FrameHistoryObj);		// create new frame
	var fdata1 = (hidx1 === -1) ? null : HISTORY[hidx1];
    //if (hidx1 === -1) { console.log("151:  NO FDATA1  hidx=",hidx);  return; }

	var fpose = fdata.pose;
	var stats = fdata.stats;
	var stats1 = (fdata1) ? fdata1.stats : null;
	var fpose1 = (hidx1 == -1) ? null : fdata1.pose;
	var lfemur, rfemur;

    //if ((hidx % 400) == 0) console.log("411:    . . . . . . POSE HIDX=",hidx, " trail3d=",fdata.trail3d);       // show heardbeat
    //console.log("387:    . . . . . . timestamp=",timestamp, "  webcam_start=",TIMES.webcam_start);
    //console.log("0172:    . . . . . . hidx=",hidx, "  pose=",pose);

    fdata.hidx = hidx;
	fdata.pixel_ratio = CONSTS.FEMUR_PIXEL_RATIO_SEED;	// convert ratio to ft, based on eyes, hips and ball
	fdata.ref_y = CONSTS.FEMUR_REF_Y_SEED;			// reference Y location where the pixel_ratio is valid
	fdata.ref_femur = CONSTS.FEMUR_REF_SEED;		// reference femur length at ref_y
	fdata.ratio_femur_y = CONSTS.FEMUR_RATIO_Y_SEED;		// slope of D-femur v D-Y, use to calc depth
	fdata.timestamp = timestamp;
	fdata.timestamp_show = formatTimestamp(timestamp - TIMES.webcam_start, 5);

	fpose.keypoints = {...pose.keypoints};
	fpose.keypoints3D = {...pose.keypoints3D};


    // 2D keypoints
	var reye = pose.keypoints[INFO.idx["left_eye"]];		// left eye
	var leye = pose.keypoints[INFO.idx["right_eye"]];		// right eye
	var rear = pose.keypoints[INFO.idx["left_ear"]];		// left ear
	var lear = pose.keypoints[INFO.idx["right_ear"]];		// right ear
	var lhip = pose.keypoints[INFO.idx["left_hip"]];
	var rhip = pose.keypoints[INFO.idx["right_hip"]];
	var lknee = pose.keypoints[INFO.idx["left_knee"]];
	var rknee = pose.keypoints[INFO.idx["right_knee"]];
	var lank = pose.keypoints[INFO.idx["left_ankle"]];
	var rank = pose.keypoints[INFO.idx["right_ankle"]];
	var lhel = pose.keypoints[INFO.idx["left_heel"]];
	var rhel = pose.keypoints[INFO.idx["right_heel"]];
	var lsho = pose.keypoints[INFO.idx["left_shoulder"]];
	var rsho = pose.keypoints[INFO.idx["right_shoulder"]];
	var lelb = pose.keypoints[INFO.idx["left_elbow"]];
	var relb = pose.keypoints[INFO.idx["right_elbow"]];
	var lwri = pose.keypoints[INFO.idx["left_wrist"]];
	var rwri = pose.keypoints[INFO.idx["right_wrist"]];
	//var lank = (pose.keypoints[15] > 0) ? pose.keypoints[15] : 0;	// left ankle
	//var rank = (pose.keypoints[16] > 0) ? pose.keypoints[16] : 0;	// right ankle
	var leyex = leye.x;
	var leyey = leye.y;
	var reyex = reye.x;
	var reyey = reye.y;
	var learx = lear.x;
	var leary = lear.y;
	var rearx = rear.x;
	var reary = rear.y;
	var lshoy = lsho.y;
	var rshoy = rsho.y;
	var lhipx = lhip.x;
	var lhipy = lhip.y;
	var rhipx = rhip.x;
	var rhipy = rhip.y;
	var lkneex = lknee.x;
	var lkneey = lknee.y;
	var rkneex = rknee.x;
	var rkneey = rknee.y;
	var top = (leye.y > reye.y) ? leye.y : reye.y;   // choose lower
	var bottom = (lank.y > rank.y) ? lank.y : rank.y;   // choose lower
    //console.log("store_pose.156:  leye=",leye, " INFO.idx=",INFO.idx);

    // XXCD.TODO: NEED TO CHANGE THIS OVER TO 3D (process3DSignals)
	// collect raw stats here, need to filter it in analysis
	lfemur= calcPixelDistance(lhipx, lkneex, lhipy, lkneey);
	rfemur= calcPixelDistance(rhipx, rkneex, rhipy, rkneey);
	fdata.pose.femur_length0 = (lfemur + rfemur) / 2;
	fdata.pose.femur_length = fdata.pose.femur_length0;   // Note: this should be expon smoothed
	fdata.pose.femur_prob = Math.floor((lhip.score + lknee.score + rhip.score + rknee.score)/4*100);
	fdata.pose.eyes_width = calcPixelDistance(reyex, leyex, reyey, leyey);
	fdata.pose.eyes_prob = Math.floor((leye.score + reye.score)/2*100);
	fdata.pose.head_width = calcPixelDistance(rearx, learx, reary, leary);
	fdata.pose.head_prob = Math.floor((lear.score + rear.score)/2*100);
	fdata.pose.hip_width = calcPixelDistance(rhipx, lhipx, rhipy, lhipy);

	fdata.pose.sho_prob = Math.floor((lsho.score + rsho.score)/2*100);
	fdata.pose.hip_prob = Math.floor((lhip.score + rhip.score)/2*100);
	fdata.pose.knee_prob = Math.floor((lknee.score + rknee.score)/2*100);
	fdata.pose.ank_prob = Math.floor((lank.score + rank.score)/2*100);
	fdata.pose.heel_prob = Math.floor((lhel.score + rhel.score)/2*100);
	fdata.pose.elb_prob = Math.floor((lelb.score + relb.score)/2*100);
	fdata.pose.wri_prob = Math.floor((lwri.score + rwri.score)/2*100);

	fdata.pose.bottom0 = (fpose1) ? fpose1.bottom : null;       // this is the last frame for expon smooth, DIFF for ctr_x0!!!
	fdata.pose.sho_y = Math.floor((lshoy + rshoy) / 2);
	fdata.pose.ctr_x = Math.floor((lhipx + rhipx) / 2);
	fdata.pose.ctr_y = Math.floor((lhipy + rhipy) / 2);
	fdata.pose.ctr_x0 = fpose.ctr_x;   //(fpose1) ? fpose1.ctr_x : null;       // Note: Intentional here, do not chg
	fdata.pose.ctr_y0 = fpose.ctr_y;   //(fpose1) ? fpose1.ctr_y : null;       // Note: Intentional here, do not chg
	fdata.pose.ctr_by = birdseyeY(stats, fpose.ctr_y);
	fdata.pose.top = Math.floor(top);
	fdata.pose.top_prob = Math.floor((fpose.eyes_prob + fpose.head_prob)/2);
	fdata.pose.bottom = Math.floor(bottom);
	fdata.pose.bottom_prob = Math.floor((fpose.ank_prob + fpose.heel_prob)/2);
    //console.log("anal.439:  ",hidx,"  # # # # # # # # # # # # # # # # # # 2D SCORE:  top=",fpose.top_prob, " bot=",fpose.bottom_prob, " sho=", fpose.sho_prob, "  elb=", fpose.elb_prob,"  wri=", fpose.wri_prob, "  hip=", fpose.hip_prob,"  knee=", fpose.knee_prob,"  ankle=", fpose.ank_prob);

    fdata.pose.signals = process3DSignals(pose.keypoints3D);       // signal from the body, used later
    if ((fpose.signals !== null) && (INFO.reps_running === true)) {
        if (fpose.signals.look_down !== true) {
            INFO.heads_up_frames = INFO.heads_up_frames + 1;      // for h00 calc
            //console.log("anal.361:  ",hidx," ................+++++++ HEAD IS UP  ", fpose.signals.look_down,  " cnt=",INFO.heads_up_frames);
        } else {
            //console.log("anal.363:  ",hidx," ....................... HEAD IS DOWN   ", fpose.signals.look_down);
        }
        INFO.valid_frames = INFO.valid_frames + 1;
    }

    // exponential smooth the limb degrees
    //
	if(fpose1) {
        var sigs0 = fpose.signals;
        var sigs1 = fpose1.signals;
        for (var key in sigs0) {
            var limb0 = sigs0[key];
            var limb1 = sigs1[key];
            if (limb0.degree && limb1.degree) {
                limb0.degree =  Math.floor((CONSTS.EXPON_LIMB_DEG * limb0.degree) + ((1 - CONSTS.EXPON_LIMB_DEG) * limb1.degree));
            }
        }
    }

	var height = rank.y - top;
	if(lank.y > rank.y) {
	    height = lank.y - top;
    }

    //console.log("pose.183:  DEBUG  eyes=", Math.floor(fpose.eyes_prob), " head=", Math.floor(fpose.eyes_prob));
    fdata.pose.has_head = false;
    if (fpose.top_prob > CONSTS.GOAL_HEAD_ACCURACY) {
        //console.log("pose.293:                + + + + + +         HEAD DETECTED  eyes=", Math.floor(fpose.eyes_prob), " head=", Math.floor(fpose.head_prob), " ank_prob=",Math.floor(fpose.ank_prob));
        fdata.pose.has_head = true;
    }

    fdata.pose.has_feet = false;
    if (fpose.bottom_prob > CONSTS.GOAL_FEET_ACCURACY) {
        //console.log("pose.299                + + + + + +         FEET DETECTED  ankles=", Math.floor(fpose.ank_prob));
        fdata.pose.has_feet = true;
    }


	fdata.pose.height = height;		// affected by pose so not accurate
	//console.log("231:   femur.score=",fpose.femur_prob, "ht=", fpose.height, "ctr_x=", fpose.ctr_x, "ctr_y=", fpose.ctr_y, "  lhipx=", parseInt(lhipx), " rhipx=", parseInt(rhipx), " lhipy=", parseInt(lhipy), "rhipy=", parseInt(rhipy));
	if (fpose.femur_prob > MIN_POSE_USABLE_SCORE) {
        //console.log("GOOD.POSE: valid=",pose.valid, " hip=", fpose.hip, "ctr_x=", fpose.ctr_x, "ctr_y=", fpose.ctr_y, "  lhipx=", lhipx, " rhipx=", rhipx, " lhipy=", lhipy, "rhipy=", rhipy);
        fdata.pose.valid = true;
        no_pose = false;



        INFO.femur_px = fpose.femur_length;
        //var ref_femur1 = (stats1) ? stats1.ref_femur : null;
        var ref_femur1 = (fpose1) ? fpose1.femur_length : null;
        //console.log("femur.285:        FEMUR:    femur=",fpose.femur_length, " ref_femur1=",ref_femur1," lfemur=",lfemur, " rfemur=", rfemur, " prob=",parseInt(fpose.femur_prob));



	} else {
        // XXCD.KLUDGE: for blazepose there is no pose.score currently
        //console.log("322:        FEMUR:    ! ! ! ! ! ! ! ! ! ! !  BAD   femur=",fpose.femur_length0, "  prob==",fpose.femur_prob);
		//fdata.pose.valid = true;
		//no_pose = false;
		fdata.pose.valid = false;
		no_pose = true;
    }

	if (no_pose) {
		// if no ball, use the last valid for continuity
		fdata.pose.eyes_width = Peye;
		fdata.pose.head_width = Phead;
		fdata.pose.hip_width = Phip;
		fdata.pose.ctr_x = Pctr_x;
		fdata.pose.ctr_y = Pctr_y;
		fdata.pose.ctr_by = Pctr_by;
		fdata.pose.top = Ptop;
		STATS.no_poses = STATS.no_poses + 1;
	} else if (fdata.pose.valid === true) {
		// store the last valid, in case later frame found no ball
		Peye = fpose.eyes_width;
		Phead = fpose.head_width;
		Phip = fpose.hip_width;
		Pctr_x = fpose.ctr_x;
		Pctr_y = fpose.ctr_y;
		Pctr_by = fpose.ctr_by;
		Ptop = fpose.top;

		STATS.has_poses = STATS.has_poses + 1;
        INFO.conseq_bad_poses = 0;
	} else {
		STATS.bad_poses = STATS.bad_poses + 1;
        INFO.conseq_bad_poses = INFO.conseq_bad_poses + 1;
	}


	// smoooth out body movment by apply expo smoothing to ctr, 
	// KLUDGE: currently keypoints are NOT shifted
	//
    var last_femur = (INFO.ref_femur) ? INFO.ref_femur : 50;
    var last_y = (INFO.ref_y) ? INFO.ref_y : 0;
    var femur_length = 0;
	if(fpose1 !== null) {
		//fdata.pose.femur_length = fpose1.femur_length;		// carry it forward until reset
		//fdata.pose.femur_length =  Math.floor((CONSTS.EXPON_POSE_FEMUR * fpose.femur_length) + ((1 - CONSTS.EXPON_POSE_FEMUR) * fpose1.femur_length));
		last_femur =  fpose1.femur_length;

		fdata.pose.ctr_x =  Math.floor((CONSTS.EXPON_POSE_CTRX * fpose.ctr_x0) + ((1 - CONSTS.EXPON_POSE_CTRX) * fpose1.ctr_x));
		fdata.pose.ctr_y =  Math.floor((CONSTS.EXPON_POSE_CTRY * fpose.ctr_y0) + ((1 - CONSTS.EXPON_POSE_CTRY) * fpose1.ctr_y));
		fdata.pose.ctr_by = birdseyeY(stats, fpose.ctr_y);
		//console.log("pose.131:  ", hidx, "   ctr_x=",fpose.ctr_x, " ctr_x0=",fpose.ctr_x0, " ctr_y=",fpose.ctr_y, " ctr_y0=", fpose.ctr_y0);
	}

    // filter out abrupt femur length chgs
    //    - if same_y & big delta 
    //    - if same_y & big delta 
    //
    var bad_femur = false;
    var femur_delta = Math.abs(fpose.femur_length - last_femur);
    if (((femur_delta / last_femur) > CONSTS.FEMUR_MAX_DIFF_VARIANCE)) { bad_femur = true; }

    /* Note: OLD - same_y does not work with certain camera angles
    //
    var same_y = (Math.abs(fpose.ctr_y - last_y) < 2) ? true  : false;      // new y position
    if ((same_y === true) && ((femur_delta / last_femur) > CONSTS.FEMUR_MAX_SAME_VARIANCE)) { bad_femur = true; }
    if ((same_y === false) && ((femur_delta / last_femur) > CONSTS.FEMUR_MAX_DIFF_VARIANCE)) { bad_femur = true; }
    */


    if (bad_femur === true) {
		femur_length =  INFO.ref_femur;
        INFO.femur_bad_count = INFO.femur_bad_count + 1;
        if (INFO.femur_bad_count > CONSTS.FEMUR_MAX_BAD) {
            //console.log("femur.1395:    ! ! ! ! ! ! ! !  FEMUR RESET   hidx=",hidx, " delta=",femur_delta.toFixed(2), "  last=", last_femur, " this=",fpose.femur_length, " bad=",INFO.femur_bad_count);
            femur_length =  fpose.femur_length;      // reset
            INFO.ref_femur = femur_length;           // reset
        }
    } else {
		femur_length =  Math.floor((CONSTS.EXPON_POSE_FEMUR * fpose.femur_length) + ((1 - CONSTS.EXPON_POSE_FEMUR) * last_femur));
        INFO.femur_bad_count = 0;
    }
    //var sfemur = (CONSTS.EXPON_FEMUR * femur_length) + ((1 - CONSTS.EXPON_FEMUR) * INFO.ref_femur);    REDUNDANT


	/* OLD: run micro-slope histogram study to determine actual femur length with accuracy
	//
    //var valid_m = storeFemurData(canvas_height, fpose.top, fpose.ctr_y, fpose.bottom, fpose.femur_length0,fpose.top_prob, fpose.bottom_prob);
	if(!stats1 || (stats1.ref_femur == null) || ((valid_m % 1000) == 100)) {
		// recalibrate golden femur once in a while to preserve stability
        //[femur_len, y_position, y_ratio ] = setFemurLength();
	} */


    // bypass histogram, use current expon-smooth value
    //femur_len = fdata.pose.femur_length;     // Note: Use the expon smooth version
    y_position = fpose.ctr_y;
    y_ratio = femur_length / CONSTS.FEMUR_AVG_M;
    fdata.stats.ref_y = y_position;
    fdata.stats.ratio_femur_y = y_ratio;			// use to adjust pixel_ratio
    INFO.ref_y = y_position;
    INFO.ratio_femur_y = y_ratio;

    fdata.stats.ref_femur0 = fpose.femur_length;   // raw, for debug
    INFO.ref_femur0 = fpose.femur_length;   // for quick access
    INFO.ref_femur1 = femur_length;          // back up in case we need it
    if ((INFO.perf_running === false) && (INFO.reps_running === false) && (INFO.defender_running === false)) {
        INFO.ref_femur = femur_length;          // DO NOT CHANGE INFO.ref_remur during a active run!
        fdata.stats.ref_femur = femur_length;
        fdata.pose.femur_length = femur_length;		// use from above
    } else {
        fdata.stats.ref_femur = INFO.ref_femur;
        fdata.pose.femur_length = INFO.ref_femur;		// use from above
    }

    //console.log("afem.367:             . , .  hidx=",hidx, " hidx1=",hidx1,"  stats.ref_femur=", stats.ref_femur, " femur_len=",femur_len, " pose.femur_lne=",fdata.pose.femur_length," ref_y=", y_position, "  raio_femur_y=",parseInt(y_ratio));


	/* calculate valid femur measurement at this Y
	if(stats.ref_femur !== null) {
		var m = (stats.ratio_femur_y / 100);
		var fm0 = (stats.ref_femur == null) ? 0 : stats.ref_femur;
		var yy0 = stats.ref_y;
		var dy =  (yy0 / m) - (fpose.ctr_y / m);
		var fm1 = fm0 + (m * (fpose.ctr_y - yy0));
		//fdata.stats.pixel_ratio =  (fm1 / 0.3 8); 	// kids femur is 38 cm
		fdata.stats.pixel_ratio =  (fm1 / CONSTS.FEMUR_AVG_M); 	// kids femur is 38 cm

		//console.log("afem.184:  m=",m.toFixed(1)," ctr_y=",fpose.ctr_y, " yy0=",yy0," fm0=",fm0.toFixed(1),
		//		" new_femur=", fm1.toFixed(1), "  raw_femur=", fpose.femur_length.toFixed(1),"   m_cnt=",STATS.valid_femur_m_cnt);
	} else {
		// no statistical data yet, use raw value
		fdata.stats.pixel_ratio =  (femur_length / CONSTS.FEMUR_AVG_M); 	// kids femur is 38 cm
	} */

    fdata.stats.pixel_ratio =  (femur_length / CONSTS.FEMUR_AVG_M); 	// kids femur is 38 cm

	if(fpose.valid == true) {
		STATS.pixel_ratio = stats.pixel_ratio;
		INFO.pixel_ratio = stats.pixel_ratio;
        //var ht_m = calcPixel2Meter(STATS.pixel_ratio, fpose.height);      // check height
		//console.log("afem.227:  pix_ratio=", stats.pixel_ratio, " ref_femurm=",stats.ref_femur," stats=",stats, " yy0=",stats.ref_y);
		//console.log("afem.397:             . , .  hidx=",hidx, " fpose.femur0=",fpose.femur_length0, "  stats.ref_femur=", stats.ref_femur, " ref_y=", y_position, "  ratio_femur_y=",parseInt(stats.pixel_ratio));
	}

	HISTORY.push(fdata);
	STATS.tot_frames = STATS.tot_frames + 1;
    //console.log("afem.463:             ADD POSE FRAME . . .  hidx9=",hidx9, " now=",parseInt(performance.now()), " started=", parseInt(TIMES.inference_started));
}



// capture ball data into frame for later analysis
//
var Bctr_x=0, Bctr_y=0, Bctr_by=0, Bbox_x=0, Bbox_y=0;
export function storeBallData(boxes, img_ratio, image_width, image_height) {
	var hidx = HISTORY.length - 1;
	var fdata = HISTORY[hidx];
	var hidx1 = nextValidBallFrame(hidx - 1);		// previous valid frame
	var fdata1 = HISTORY[hidx1];
	var ball = fdata.ball;
	var stats = fdata.stats;
	var ball1 = (fdata1 == undefined) ? null : fdata1.ball;
	var pose = fdata.pose;
	var cones = [];
	var object, prob = 0;
	var no_ball = true, has_soccer = false, bad_ball = 0, sad_ball = 0;

	for(var b = 0; b < boxes.length; b++) {
		var box = boxes[b];
		//console.log("storeSoccerData.56: box=",box);
		object = null;
		switch(box.class) {
			case "soccer":		// soccer
				object = ball;
				has_soccer = true;
				//console.log("storeSoccerData.56: SOCCER box=",box);
				break;
			case "cone":		// cone
				object = cone;
				break;
			default:
				console.log("260: ERROR: unknown BOX.CLASS ",box.class)
				break;
			/**/
		}

		if((box.class == "soccer") && (box.score > prob)) {
			//console.log("100: STORE_BALL  bb_x=", box.width, " bb_y=", box.height, " img_ratio=", img_ratio, " s_width=", image_width)
			ball.x0 = Math.floor(box.left / img_ratio);
			ball.y0 = Math.floor(box.top / img_ratio);
			ball.x1 = Math.floor((box.left + box.width) / img_ratio);
			ball.y1 = Math.floor((box.top + box.height) / img_ratio);
			ball.bb_x = Math.floor(box.width / img_ratio);
			ball.bb_y = Math.floor(box.height / img_ratio);
			ball.ctr_x = Math.floor(ball.x0 + (ball.bb_x / 2))
			ball.ctr_y = Math.floor(ball.y0 + (ball.bb_y / 2))
			ball.ctr_x0 = ball.ctr_x;
			ball.ctr_y0 = ball.ctr_y;
			ball.ctr_by = birdseyeY(stats, ball.ctr_y);
			ball.prob = Math.floor(box.score * 100);
			//console.log("ball.115: VALID ",b,": class=",box.class,"  ctr_x=",ball.ctr_x, " ctr_y=",ball.ctr_y, " score=",ball.prob);

			ball.valid = true;
			if(((image_width/ball.x0) > 12) || ((image_height/ball.y0) > 12) ||
			   (ball.score < 0.10) || (ball.bb_x == 0) || (ball.bb_y == 0) ||
			   (ball.x0 == 0) || (ball.y0 == 0)) {
				ball.valid = false;		// size too big or loow confidence,
				bad_ball = 1;
				//console.log("     invalid ball bx0=",ball.x0, " by0=",ball.y0);
			}

			// check if ball is square, if not force it
			//
			prob = box.score;			// KLUGE: only for soccer
			var bwidth = ball.bb_x;
			var bheight = ball.bb_y;
			var ratio = bheight / bwidth;
			if(ratio !== 1) {
				// fix all to square, but only count the really bad ones
				if((ratio > 1.50) || (ratio < 0.50)) {
					sad_ball = 1;
				}

				//console.log("     long ball bw=",bwidth, " bh=",bheight);
				if(bwidth > bheight) {
					var delta = bwidth - bheight;
					//console.log("ADJUST BALL: old_x=", ball.bb_x, " new_x=",bheight, " old_y=", ball.bb_y);
					ball.bb_x = bheight;
					ball.x0 = ball.x0 + (delta / 2);
					ball.x1 = ball.x1 - (delta / 2);
				} else  if (bwidth < bheight) {
					var delta = bheight - bwidth;
					//console.log("ADJUST BALL: old_y=", ball.bb_y, " new_y=",bwidth, " old_x=", ball.bb_x);
					ball.bb_y = bwidth;
					ball.y0 = ball.y0 + (delta / 2);
					ball.y1 = ball.y1 - (delta / 2);
				} 
			} else {
				sad_ball = 0;
			}
			no_ball = false;
		}

		// record raw cones here, then we process it with
		// cumulative cone detection:
		//    - carry over from prev frames and add count
		//    - eliminate non-repeat ones
		if((box.class == "cone") && (box.score > 0.1)) {
			var cone = {}, x0, y0, x1, y1, bb_x, bb_y;
			x0 = Math.floor(box.left / img_ratio);
			y0 = Math.floor(box.top / img_ratio);
			x1 = Math.floor((box.left + box.width) / img_ratio);
			y1 = Math.floor((box.top + box.height) / img_ratio);
			bb_x = Math.floor(box.width / img_ratio);
			bb_y = Math.floor(box.height / img_ratio);
			cone.ctr_x = Math.floor(x0 + (bb_x / 2))
			cone.ctr_y = Math.floor(y0 + (bb_y / 2))
			cone.ctr_by = birdseyeY(stats, cone.ctr_y);
			cone.width = Math.floor(box.width);
			cone.height = Math.floor(box.height);
			cone.prob = Math.floor(box.score * 100);
			cone.valid = true;
			cones = cones.concat(cone);
			//console.log("cones.150: ",b,": class=",box.class,"  ctr_x=",cone.ctr_x, " ctr_y=",cone.ctr_y, " score=",cone.prob);
			//console.log("cones.151: ",cones);
		}
	}

	fdata.cones = [...cones];
	ball.ctr_x0 = ball.ctr_x;
	ball.ctr_y0 = ball.ctr_y;
	

	// if no ball info, use old bounding box
	//
	//console.log("ball.163:  no_ball=",no_ball, " has_soccer=",has_soccer);
	if(no_ball == true) {		// every frame must have ball info, even if just cones
		// if no ball, use the last valid for continuity
		//console.log("ball.166: DEFAULT Bbx=",Bbox_x, " Bby=",Bbox_y, "  Bcx=",Bctr_x, "  Bcy=",Bctr_y);
		ball.bb_x = Bbox_x;
		ball.bb_y = Bbox_y; 
		ball.bb_x0 = Bbox_x;
		ball.bb_y0 = Bbox_y; 
		ball.ctr_x = Bctr_x;
		ball.ctr_y = Bctr_y;
		ball.ctr_x0 = Bctr_x;
		ball.ctr_y0 = Bctr_y;
		ball.ctr_by = Bctr_by;	// birds eye Y
		STATS.no_balls = STATS.no_balls + 1;
		STATS.no_ball_cnt = STATS.no_ball_cnt + 1;

		if(pose.valid == false) {
			STATS.no_nothing = STATS.no_nothing + 1;
		}
	}

	if(ball.valid == true) {
		// store the last valid, in case later frame found no ball
		Bbox_x = ball.bb_x;
		Bbox_y = ball.bb_y;
		Bctr_x = ball.ctr_x;
		Bctr_y = ball.ctr_y;
		Bctr_by = ball.ctr_by;
		//console.log("ball.175: *** NEW SET Bbx=",Bbox_x, " Bby=",Bbox_y, "  Bcx=",Bctr_x, "  Bcy=",Bctr_y);
		STATS.has_balls = STATS.has_balls + 1;
		STATS.no_ball_cnt = 0;
	}

	// generate expon smoothed ball center, adjust box
	//
	if(ball1 !== null) {
		ball.ctr_x =  Math.floor((CONSTS.EXPON_BALL_CTRX * ball.ctr_x0) + ((1 - CONSTS.EXPON_BALL_CTRX) * ball1.ctr_x));
		ball.ctr_y =  Math.floor((CONSTS.EXPON_BALL_CTRY * ball.ctr_y0) + ((1 - CONSTS.EXPON_BALL_CTRY) * ball1.ctr_y));
		ball.ctr_by = birdseyeY(stats, ball.ctr_y);
		var delta_x = ball.ctr_x - ball.ctr_x0;
		var delta_y = ball.ctr_y - ball.ctr_y0;
		ball.x0 = ball.x0 + delta_x;
		ball.x1 = ball.x1 + delta_x;
		ball.y0 = ball.y0 + delta_y;
		ball.y1 = ball.y1 + delta_y;
	}


	// collect aggregate stats
	//
	//console.log("330.store4: cones=",cones);
	STATS.bad_balls = STATS.bad_balls + bad_ball;	// only count once
	STATS.sad_balls = STATS.sad_balls + sad_ball;	// only count once
	if(STATS.no_ball_cnt > 2) {
		if(STATS.no_ball_cnt > 5) {
			STATS.no_ball6 = STATS.no_ball6 + 1;	// track of long runs
			STATS.no_ball_cnt = 0;	// reset it to avoid too many dup cnts
		} else {
			STATS.no_ball3 = STATS.no_ball3 + 1;
		}

	}
}



//
// determine direction and speed of the ball movement
// flag when direction changes and count as a touch, need 2 confirming data to chg
//     - if msect, then find frame at least msec apar
//     - for speed calc, to avoid "instantaneous speed"
//
// throw out invalid frame or if body has not moved
function nextValidPoseFrame(hidx, msec) {
    if(!HISTORY[hidx]) { return -1};

    var stime = HISTORY[hidx].timestamp;
	for(var i= (hidx - 1); i >= 0; i--) {
		//console.log("HISTORY["+i+"]=", HISTORY[i]);
		var pose = HISTORY[i].pose
		var trail = HISTORY[i].trail
        var etime = HISTORY[i].timestamp;
		if((pose.valid == true)) {
			if(trail.px !== null) {
				if (trail.pvalid == false) {
					return -1;		// if trail is set, then pose need to be valid
				}
			}

            if (msec) {
                if ((stime - etime) > msec) {
                    //console.log("99:                INTERVAL FOUND . .   msec=",msec,"  index=",i,"  hidx=",hidx, " t.px=", trail.px, " stime=",stime%100000/1000, " etime=",etime%100000/1000, " dtime=",(stime - etime));
                    return i;
                }
            } else {
                //console.log("95:        NEXT HIDX  . . .    index=",i,"  hidx=",hidx, " t.px=", trail.px, " stime=",stime%100000/1000, " etime=",etime%100000/1000, " dtime=",(stime - etime));
                return i;
            }
		}
	}
	return -1;
}


// throw out invalid frame or if ball has not moved
function nextValidBallFrame(hidx, x, y) {
	for(var i= hidx; i >= 0; i--) {
		//console.log("HISTORY["+i+"]=", HISTORY[i]);
		var ball = HISTORY[i].ball
		var trail = HISTORY[i].trail
		if((ball.valid == true) && !((ball.ctr_x == x) && (ball.ctr_y == y))) {
			if(trail.bx !== null) {
				if (trail.bvalid == false) {
					return -1;		// if trail is set, then ball need to be valid
				}
			}
			//console.log("95:  found valid hidx=", i, " ctr_x=", ball.ctr_x, " x=", x,"  ctr_y=", ball.ctr_y, "  y=",y)
			return i;
		}
	}
	return -1;
}

// project out the current direction by storing dx & dy sum in target
// if new (x,y) is further from the target, then may be start of a direction chg 
//
function calcTrail(hidx, stats, x1, x0, y1, y0, t1, t0, basex, basey, targx, targy, targdist, reverse) {
	var trail = {}, dist, otargdist, t1targdist;
    //if ((hidx < 5) || ((INFO.has_calibration === false) && (INFO.override.show_ratio === false))) return {};
    //if (hidx < 5) return;

	//console.log("trail.425: x1=",x1," x0=",x0, " y1=",y1, " y0=",y0);
	//var dx = x0 - x1;	// x1 is the new one, x0 is old!
	//var dy = y0 - y1;
	var dx = x1 - x0;	// x1 is the new one, x0 is old!
	var dy = y1 - y0;
	dist = calcDistance(stats, x1, x0, y1, y0);
	//trail.degree = calcDegree(stats, x1, x0, y1, y0);
	trail.degree = calcDegree(stats, x1, basex, y1, basey);		// use base coord more stable
	trail.hidx = hidx;
	//trail.x = x1;
	//trail.y = y1;
	trail.x = x1;
	trail.y = y1;
	trail.dist = dist;
	trail.dt = Math.floor(t1 - t0);		// in msec
	trail.flip = false;
	targx = (targx == undefined) ? 0 : targx;
	targy = (targy == undefined) ? 0 : targy;
	reverse = (reverse == undefined) ? 0 : reverse;
	targdist = (targdist == undefined) ? 0 : targdist;

	// SPECIAL ALGO: Maintain a projected target vector along current direction
	//      - each coord in same direction lengthens the vector and make it more accurate
	//      - each new coord need to get closer to the last target (and target grows)
	//      - when new coord gets further, it means direction chgd
	//      - after X times we decide we are off the vector
	//	    - this got around the whole "opposite direction" heuristic mess
	trail.otargdist = calcDistance(stats, x0+targx, x0, y0+targy, y0);	// old coord to old target
	t1targdist = calcDistance(stats, x0+targx, x1, y0+targy, y1);	// new coord to old target

	if ((t1targdist < trail.otargdist) || (trail.otargdist < CONSTS.BALL_MIN_TARGET_DISTANCE)) {
		// got shorter, so going in same direction or not in a clear trend
		trail.reverse = 0;		// wipe out previous reverse count
	} else {
        if (INFO.has_calibration === true) {
            trail.reverse = reverse + 1;		// wipe out previous count
            //console.log("trail.924:   . . . REVERSE   hidx=",hidx, " reverse=",trail.reverse,"  t1targdist=", t1targdist, " trail.otargdist=", trail.otargdist,
            //            " x0=",x0," x0+targx=",x0+targx, " x1=",x1, " y0=",y0," y0+targy=",y0+targy, " y1=",y1);
        }
	}

	if(trail.reverse > CONSTS.BALL_REVERSE_CNT_THRESHOLD) {
		// direction change confirmed
		trail.flip = true;
		trail.targx = 0;	// start over
		trail.targy = 0;	

		trail.basex = x1;	// set new base coord to current spot
		trail.basey = y1;	
	} else {
		trail.targx = targx + (dx * 5);	// project vector out
		trail.targy = targy + (dy * 5);	// project vector out
		trail.basex = basex;	// keep old base coord
		trail.basey = basey;	

		trail.targdist = calcDistance(stats, x1+trail.targx, x1, y1+trail.targy, y1);
		trail.targdegree = calcDegree(stats, x1+targx, basex, y1+targy, basey);
	}

	// convert px to ft/sec speed, based on ball with
	//trail.speed = Math.floor(dist / (t1 - t0) * 1000);
	//var speed = (trail.dist / trail.dt) * ratio;		// conver to ft per sec
	//var [ft_speed, m_speed]= calcSpeed(stats, dist, trail.dt);
	//trail.speed = m_speed;
	var speedf = calcSpeed(stats, dist, trail.dt);
	trail.speed = speedf

	//console.log("trail.335: "+hidx+":     x1="+x1+"  y1="+y1+"    dist="+dist+"  speed="+trail.speed.toFixed(2)+"  dir="+trail.degree);
	//console.log("trail.571: "+hidx+":     x1="+x1+"  y1="+y1+" t.x="+(x1+trail.targx)+" t.y="+(y1+trail.targy)+"   t.dist="+trail.targdist+
	//			" rev=",trail.reverse+ " o.dist="+targdist+ "  o.tx="+targx+" o.ty=",targy+"  o.rev="+reverse+" flip=",trail.flip);
	return trail;
}


// 
// look back in history and return trail segment
// need to do smoothing so trail makes sense, use previous segment to calc speed
//    - make a trail object for newest one
//    - review the last 3 valid frames to filter out bad frames
//
// NOTE: ALL NEW FIELDS MUST BE *DECLARED* IN "FrameHistoryObj" FIRST
//
function genBodyBallTrails() {
	var hidx = HISTORY.length - 1;
    //if ((hidx < 5) || ((INFO.has_calibration === false) && (INFO.override.show_ratio === false))) return;
    //if (hidx < 5) return;

	var f0 = HISTORY[hidx];
	var f1 = HISTORY[hidx-1];
	var trail = null;
	var trail1 = null;
	var px0 = -1, px1 = -1, py0 = -1, py1 = -1, pt0, pt1;
	var bx0 = -1, bx1 = -1, by0 = -1, by1 = -1, bt0, bt1;
	var pby, pbx, ptx, pty, ptd, ptr, bby, bbx, btx, bty, btd, btr;
	var f, f1, f01, f2, f3, pose, p1pose, ball, bcnt = 0, pcnt = 0, ball_w, stats, ratio;
	var btrail = {}, ptrail = {}, p1trail;
    var sigs, sigs1, trail3d, trail3d1, markers;

	// generate the lastest trail record
	for (var i = hidx; i > 0; i--) {
		f = HISTORY[i];
		f01 = HISTORY[i-1];
		pose = f.pose;
		ball = f.ball;
		stats = f.stats;
		trail = f.trail;    // body pose trail
		trail3d = f.trail3d;    // body pose trail
		markers = f.markers;
		sigs = f.pose.signals;
		ratio = stats.pixel_ratio;

		trail3d1 = f01.trail3d;    // body pose trail
		sigs1 = f01.pose.signals;

		//console.log("trail.943: hidx=",hidx,"  f=",f);
		//console.log("trail.331: hidx=",hidx,"  pose.v=", pose.valid, "  b.valid=",ball.valid)
		if(pose.valid == true) {
			px0 = pose.ctr_x;
			py0 = pose.ctr_y;
			pt0 = f.timestamp;
			pbx = trail.pbasex;		// for degree calc
			pby = trail.pbasey;
			ptx = trail.ptargx;		// for direction target calc
			pty = trail.ptargy;
			ptd = trail.ptargdist;
			ptr = trail.preverse;
			//console.log("trail.598: ",i,"        POSE  p.tx=", trail.targx, "   p.ty=",trail.targy, " p.td",trail.ptargdist);

            var ltrail3d = {}, lmarkers = [];
			if ((px1 > 0) && (pcnt < 1)) {
				// px1 is new, px1 is old
				ptrail = calcTrail(i, stats, px1, px0, py1, py0, pt1, pt0, pbx, pby, ptx, pty, ptd, ptr);		// found starting
                if (INFO.knn_master_enable === true) {
                    [ltrail3d, lmarkers] = calc3DMotionAngles(i, sigs, sigs1, trail3d1);
                    for (var t in ltrail3d) { trail3d[t] = ltrail3d[t]; }       // only way to deep copy into the pointer obj
                    for (var m in lmarkers) { markers[m] = lmarkers[m]; }       // only way to deep copy into the pointer obj
                }
                //markers = markers.concat[lmarkers];
                //trail3d =  Object.assign({},ltrail3d);    // NOTE: COPY TO PTR DOES NOT WORK!
                //otrail3d =  Object.assign({},ltrail3d);     // COPY TO STRUCT WORKS

                //console.log("trail.977: ",i,"   * * * * *  f.trail3d=",f.trail3d, " f.markers=",f.markers, "  lmarkers=",lmarkers);
				pcnt = pcnt + 1;
			}
			px1 = px0;		// px1 is newer frame
			py1 = py0;
			pt1 = pt0;
		}


		if(ball.valid == true) {
			bx0 = ball.ctr_x;
			by0 = ball.ctr_y;
			bt0 = f.timestamp;
			bbx = trail.bbasex;		// for degree calc
			bby = trail.bbasey;
			btx = trail.btargx;		// for direction target calc
			bty = trail.btargy;
			btd = trail.btargdist;
			btr = trail.breverse;
			//if((bx1 > 0) && (bcnt < CONSTS.TRAIL_LENGTH)) 
			if((bx1 > 0) && (bcnt < 1)) {
				btrail = calcTrail(i, stats, bx1, bx0, by1, by0, bt1, bt0, bbx, bby, btx, bty, btd, btr);
				//console.log("trail.511: ",i,"              BALL TRAIL   b.tx=", btrail.targx, "   b.ty=",btrail.targy);
				bcnt = bcnt + 1;
			}
			bx1 = bx0;
			by1 = by0;
			bt1 = bt0;
		}

		//if ((pcnt > CONSTS.TRAIL_LENGTH) && (bcnt > CONSTS.TRAIL_LENGTH)) 

		//if ((pcnt > 0)) 		// KLUDGE: NO BALL RIGHT NOW!!!
		if ((pcnt > 0) && (bcnt > 0)) {
			break;
		}
	}

	trail = f0.trail;	// need to restore back to f0!
	trail1 = (f1) ? f1.trail : f0.trail;	

	trail.bx = btrail.x;
	trail.by = btrail.y;
	trail.bdist = btrail.dist;
	trail.bspeed = btrail.speed;
	trail.bspeed0 = btrail.speed;
	trail.bdegree = btrail.degree;
	trail.bdegree0 = btrail.degree;
	trail.bbasex = btrail.basex;
	trail.bbasey = btrail.basey;
	trail.btargx = btrail.targx;
	trail.btargy = btrail.targy;
	trail.btargdist = btrail.targdist;
	trail.botargdist = btrail.otargdist;
	trail.btargdegree = btrail.targdegree;
	trail.breverse = btrail.reverse;
	trail.bflip = btrail.flip;
	trail.bvalid = f0.ball.valid;
	//trail.bvalid = ((f0.ball.valid == true) && (trail.bdegree >= 0)) ? true : false;

	trail.px = ptrail.x;
	trail.py = ptrail.y;
	trail.pdist = ptrail.dist;

	trail.pspeed0 = ptrail.speed;
    trail.pspeed =  (CONSTS.EXPON_POSE_TSPEED * ptrail.speed) + ((1 - CONSTS.EXPON_POSE_TSPEED) * trail1.pspeed);

	trail.pdegree = ptrail.degree;
	trail.pdegree0 = ptrail.degree;
	trail.pbasex = ptrail.basex;
	trail.pbasey = ptrail.basey;
	trail.ptargx = ptrail.targx;
	trail.ptargy = ptrail.targy;
	trail.ptargdist = ptrail.targdist;
	trail.potargdist = ptrail.otargdist;
	trail.ptargdegree = ptrail.targdegree;
	trail.preverse = ptrail.reverse;
	trail.pflip = ptrail.flip;
	trail.pvalid = f0.pose.valid;
	//trail.pvalid = ((f0.pose.valid == true) && (trail.pdegree >= 0)) ? true : false;
	//console.log("trail.534:       . . . . .  POSE TRAIL  degree=", trail.pdegree, "   dist=",trail.pdist, "        . . . .   f0.px=",f0.trail.px, " trail.px=",trail.px);

	trail.bdist1 = f1.trail.bdist1;		// KLUDGE: seed it just in case
	trail.pdist1 = f1.trail.pdist1;		// KLUDGE: seed it just in case
	//console.log("trail.421:  ***** after store to ", hidx, "   ", HISTORY[hidx].trail);

    if (INFO.knn_master_enable === true) {
        analyzeMotionMarkers(f1.markers);		// DETECT LOOP REPS:  analyze motion signals via limb movments (not posn X)
        if (INFO.gesture_allowed === true) {
            var gestures = detectStaticMarker(f1.markers);         // STATIC GESTURE DETECTION
            if (gestures && (gestures.length > 0)) {
                INFO.knn_gestures  = INFO.knn_gestures.concat(gestures);

                var gt0 = Date.now();
                var delta = gt0 - INFO.last_gesture_time;
                if ((hidx > MIN_HIDX) && (delta > GESTURE_COOL_OFF_MSEC)) {
                    console.log("trail.946:          + + +  CALL GESTURE EVENT  hidx=",hidx,"   delta=",delta, " gt0=", (gt0 % 100000 / 1000), " last_gest=",(INFO.last_gesture_time % 100000 / 1000), " now=",(Date.now()%100000 / 1000));
                    window.dispatchEvent(INFO.gesture_detected_event);      // use signal to go across components
                    INFO.last_gesture_time = gt0;
                } else {
                    console.log("trail.949:          ! ! !  DISCARD GESTURE, TOO SOON  ",hidx,"   delta=",delta,"  gt0=", (gt0 % 100000 / 1000), " last_gest=",(INFO.last_gesture_time % 100000 / 1000), " now=",(Date.now()%100000 / 1000));
                }
            }
        }
    }

    // DEBUG: Analyzer mode to develop AI model
    //
    if (INFO.dev_analyze_mode === true) {
        displayMotionMarkers(hidx, f1.markers);        // for debug only
        displayMotionSkeleton(f1.trail3d, f1.pose.signals);        // for debug only
    }

    adjustCameraAngle();        // Note: move this out?


	//displayBlock("rgba(255,0,0, 1)", trail.pbasex, trail.pbasey, 5, 5);		// show trail center for debug
	//displayPoseTurn(STATS.pose_turn_cnt, trail.pbasex+5, trail.pbasey);		// show trail for debug
	//if ((trail.pvalid == true) && (trail.pflip == true)) {
        //processDrillReps();       // Moved up to after Defender is run
    //}


	var ctr_x, ctr_y, this_touch_time, touch_delta;
	if ((trail.bvalid == true) && (trail.bflip == true)) {
		//console.log("trail.721:  NEW TARGET BALL BASE  bbx=", trail.bbasex, "  bby=",trail.bbasey);
		processPositionTurnVectors("ball", "ball_trail.996");		// use this for figure out drill loops
		setFrameEvent("BTURN-"+STATS.ball_touch_cnt);
		console.log("anal_perf.775:   BTURN-",STATS.ball_touch_cnt, "  hidx=",hidx);

		this_touch_time = Math.floor(f0.timestamp);
		touch_delta = Math.floor(this_touch_time - last_touch_time);
		var msec = Math.floor(touch_delta)
		//console.log("TOUCH: ",STATS.ball_touch_cnt+"  ",msec, " msecs");
		
		var ctr_x = ball.ctr_x;
		var ctr_y = ball.ctr_y;
		displayBallTouch(STATS.ball_touch_cnt, ctr_x, ctr_y);
		STATS.ball_touch_cnt = STATS.ball_touch_cnt + 1;

		/* NEED TO FIGURE OUT IF WE STILL NEED THIS
		last_touch_time = this_touch_time;
		action.touch_time = msec;
		if((STATS.ball_touch_cnt % 8) == 0) 
			last_tpm = Math.floor((STATS.ball_touch_cnt - last_calc_cnt) / (this_touch_time - last_calc_time) * (1000 * 60))
			//console.log("************************ TPM: ", last_tpm, "  touches=", STATS.ball_touch_cnt);

			last_calc_time = this_touch_time;
			last_calc_cnt = STATS.ball_touch_cnt;
		*/
	}


	if (hidx < 4) {
		return;		// need more record to filter, or if bad no need to filter
	}

	// FILTER BALL: detect edge, look back ball trail and filter out glitches
	//    - filter out (-1, +1, -1) quick 1 frame degree reversals that is > 10, 
	//    - to find the 3 degree delta, need 4 frames (f, f1, f2, f3)
	//    - calc exponent smoothing of ball dgree (with 0.4), look for ">80"
	//var chk_pdir = true, chk_bdir = true;
	if (trail.bvalid == true) {
		var got_b1 = false, got_b2 = false, got_b3 = false;
		var f1trail, f2trail, f3trail;
		var f1_idx, f2_idx, f3_idx;
		for (var i = hidx - 1; i > 0; i--) {
			f1 = HISTORY[hidx-1];

			if(got_b1 == false) {
				if((f1.ball.valid == true) && (f1.trail.bvalid == true)) {
					got_b1 = true;
					f1_idx = i;
				}
			} else {
				if(got_b2 == false) {
					// need to find b2
					if((f1.ball.valid == true) && (f1.trail.bvalid == true)) {
						// go until we have two valid ball frames
						got_b2 = true;
						f2_idx = i;
					}
				} else {
					if((f1.ball.valid == true) && (f1.trail.bvalid == true)) {
						// got all 3
						got_b3 = true;
						f3_idx = i;
						//console.log("degree.469:   GOT ALL 3.....",f1_idx, "  ", f2_idx, "  ", f3_idx);

						f1trail = HISTORY[f1_idx].trail;
						f2trail = HISTORY[f2_idx].trail;
						f3trail = HISTORY[f3_idx].trail;
						var delta1 = (trail.bdegree - f1trail.bdegree) / Math.abs(trail.bdegree - f1trail.bdegree);
						var delta2 = (f1trail.bdegree - f2trail.bdegree) / Math.abs(f1trail.bdegree - f2trail.bdegree);
						var delta3 = (f2trail.bdegree - f3trail.bdegree) / Math.abs(f2trail.bdegree - f3trail.bdegree);
						//console.log("degree.469:  d1=",delta1, " d2=",delta2, " d3=",delta3);

						if (((delta1 <= 0) && (delta2 <= 0) && (delta3 <= 0)) ||
							((delta1 >= 0) && (delta2 >= 0) && (delta3 >= 0))) {

							// roughly falls in line, go back and recalc expo smoothing
							// exponent smoothing = f0.degree = 0.4 * f0.degree0 + (0.6) * f1 
							f2trail.bdegree =  (CONSTS.EXPON_TRB_DEGREE * f2trail.bdegree0) + ((1 - CONSTS.EXPON_TRB_DEGREE) * f3trail.bdegree);
							f1trail.bdegree =  (CONSTS.EXPON_TRB_DEGREE * f1trail.bdegree0) + ((1 - CONSTS.EXPON_TRB_DEGREE) * f2trail.bdegree);
							trail.bdegree =  (CONSTS.EXPON_TRB_DEGREE * trail.bdegree0) + ((1 - CONSTS.EXPON_TRB_DEGREE) * f1trail.bdegree);

							f2trail.bspeed =  (CONSTS.EXPON_BALL_SPEED * f2trail.bspeed0) + ((1 - CONSTS.EXPON_BALL_SPEED) * f3trail.bspeed);
							f1trail.bspeed =  (CONSTS.EXPON_BALL_SPEED * f1trail.bspeed0) + ((1 - CONSTS.EXPON_BALL_SPEED) * f2trail.bspeed);
							trail.bspeed =  (CONSTS.EXPON_BALL_SPEED * trail.bspeed0) + ((1 - CONSTS.EXPON_BALL_SPEED) * f1trail.bspeed);

							// KLUDGE: override it here again, there is a bug somewhere
							//
							f2trail.bdist1 = f3trail.bdist1 + f2trail.bdist;
							f1trail.bdist1 = f2trail.bdist1 + f1trail.bdist;
							trail.bdist1 = f1trail.bdist1 + trail.bdist;

							f2trail.pdist1 = f3trail.pdist1 + f2trail.pdist;
							f1trail.pdist1 = f2trail.pdist1 + f1trail.pdist;
							trail.pdist1 = f1trail.pdist1 + trail.pdist;
							break;
						} else {
							// need to kill trail1, got bad data
							//console.log("494:  "+f1_idx+"  **** BALL INVALIDED   d1=",delta1, " d2=",delta2,"  d3=",delta3);
							//console.log("494:                      f0=",trail,"  f1=",f1trail, " f2=",f2trail,"  f3=",f3trail);
							//f1trail.bvalid = false;
							break;
						}
					}
				}
			}
		}

		// need to wait till after degree is calc
		//
		findBallTurns();		// set bflip
		if(trail.bflip == true) {
			trail.bdist1 = 0
		} else {
			if (f1_idx > 0) {
				if (HISTORY[f1_idx].trail.bdist1 !== undefined) {
					trail.bdist1 = trail.bdist + HISTORY[f1_idx].trail.bdist1;
					//console.log("dist.548:  ADD BALL DIST  ", hidx, "  bdist1=",trail.bdist, "  f1=",f1_idx,"  f1.bdist1=",HISTORY[f1_idx].trail.bdist1);
				}
			}
		}
	}

	findPoseTurns();		// NOT ACTIVE: set pflip
	if(trail.pflip == true) {
		trail.pdist1 = 0;		// cumulative pose distance
	} else {
		if (f1_idx > 0) {
			if (HISTORY[f1_idx].trail.pdist1 !== undefined) {
				trail.pdist1 = trail.pdist + HISTORY[f1_idx].trail.pdist1;
				//console.log("dist.539:  ADD POSE DIST  ", hidx, "  pdist1=",trail.pdist, "  f1=",f1_idx,"  f1.pdist1=",HISTORY[f1_idx].trail.pdist1);
			}
		}
	}
	//console.log("dist.552: hidx=", hidx, "   hidx.trail=", HISTORY[hidx].trail);


	// FILTER POSE: look back pose trail and filter out glitches, human move slower than ball (not needed, using ex-smooth)
	//
	//var hidx1 = nextValidPoseFrame(hidx);		// previous valid frame
	var hidx1 = nextValidPoseFrame(hidx-1);		// previous valid frame
	if(hidx1 > 0) {
		var f1 = HISTORY[hidx1];
		p1pose = f1.pose;
		p1trail = f1.trail;
	}


}


// look at previous frames to gather:
//      cont_ball_dist:  pixel traveled continuously in same general direction
//      cont_ball_time:  starting time in this same general direction
//		stats.pixel_ratio: extract from eyes, hip, ball, need to be accurate
function calcBallStats() {
	var hidx = HISTORY.length - 1;
	var f, pose, ball, bcnt = 0, pcnt = 0, ball_w, stats, ratio;
	var e_ratio, d_ratio, f_ratio, h_ratio, b_ratio, px_ratio;

	if (hidx < 3) {
		return;
	}

}


// determine when a body reverses direction based on movement angle
// 
function findPoseTurns() {
	var hidx = HISTORY.length - 1;
	var hidx1 = nextValidPoseFrame(hidx - 1);		// previous valid frame
	var trail0 = HISTORY[hidx].trail;
	var trail1 = (hidx1 == -1) ? null : HISTORY[hidx1].trail;
	if(trail1 == null) {
		return;
	}
	//console.log("pose.654:    hidx="+hidx+"  hidx1="+hidx1+"  t0.pvalid="+trail0.pvalid+"  dgr0=",trail0.pdegree, " dgr1=",trail1.pdegree);

	/*  OBSOLETED: Replaced by the target vector method
	var flipped = false;
	if ((trail0.pvalid == true) && (trail1.pflip == false)){
		var delta = Math.abs((trail0.pdegree - trail1.pdegree + 360) % 360)
		delta = (delta > 180) ? (360 - delta) : delta;
		flipped = (delta > CONSTS.PDEGREE_DELTA_THRESHOLD) ? true : false;
		if (flipped == true) {
			//console.log("pose.737:  hidx="+hidx+"  hidx1="+hidx1+"             POSE FLIP    cum_dist=",trail1.pdist1, "  dgr0=",trail0.pdegree, " dgr1=",trail1.pdegree,"   ", trail0, trail1);
			trail0.pflip = true;
			//setFrameEvent("PFLIP");		// ENABLE LATER
		}
	}
	return flipped;
	*/
}


// determine when a ball reverses direction based on movement angle
// 
function findBallTurns() {
	var hidx = HISTORY.length - 1;
	var hidx1 = nextValidBallFrame(hidx - 1);		// previous valid frame
	var trail0 = HISTORY[hidx].trail;
	var trail1 = (hidx1 == -1) ? null : HISTORY[hidx1].trail;
	if(trail1 == null) {
		return;
	}

	var flipped = false;
	if ((trail0.bvalid == true) && (trail1.bflip == false)){
		var delta = Math.abs((trail0.bdegree - trail1.bdegree + 360) % 360)
		flipped = (delta > CONSTS.BDEGREE_DELTA_THRESHOLD) ? true : false;
		if (flipped == true) {
			//console.log("ball.714:  hidx="+hidx+" hidx1="+hidx1+"             BALL FLIP   cum_dist=",trail1.bdist1, "   dgr0=",trail0.bdegree, " dgr1=",trail1.bdegree,"   ", trail0, trail1);
			trail0.bflip = true;
			//setFrameEvent("BFLIP");		// ENABLE LATER
		}
	}
	return flipped;
}



//
// ananlyze the canvas pixel to determine a more precise location to calc velocity
// the size of ball is fixed and it can be the baseline, however only if it is accurate
//     - use heuristics to detect ball edge
//     - sorta works but not fool proof
//     - may be better to finetune the anchor box instead
//     - use histogram to capture ball color (instead of simple range)
//
const bkt_center = 6;
const bkt_spread = (bkt_center / 2) + 1;
const bkt_cnt = Math.floor(255/bkt_center);

function extractBallFromPixels(frame, swidth, sheight) {
	var ctr, xstart, xend, ystart, yend;

	var fdata = HISTORY[HISTORY.length - 1];		// created by pose
	var ctr_x = fdata.ball.ctr_x;
	var ctr_y = fdata.ball.ctr_y;
	var bwidth = fdata.ball.bb_x;
	var bheight = fdata.ball.bb_y;

	// ball is always square, force it
	if(bwidth > bheight) {
		var delta = bwidth - bheight;
		bwidth = bheight;		// no need to adjust the ctr
		fdata.ball.bb_x = bwidth;
		fdata.ball.x0 = bwidth + (delta / 2);
		fdata.ball.x1 = bwidth - (delta / 2);
	} else {
		var delta = bheight - bwidth;
		bheight = bwidth;
		fdata.ball.bb_y = bheight;
		fdata.ball.y0 = bheight + (delta / 2);
		fdata.ball.y1 = bheight - (delta / 2);
	}
	//console.log("START: bwidth=",bwidth, "  bheight=",bheight);

	var d = frame.data;		// prepare and pass in tuple-4 array
	var data = [];

	ctr = ((ctr_y * swidth) + ctr_x);	// across X
	var x_start = ctr_y * swidth;
	var x_end = (ctr_y * swidth) + swidth - 1;
	for(var j= x_start; j < x_end; j++) {
		var idx = j * 4;
		data.push(d[idx+0]);
		data.push(d[idx+1]);
		data.push(d[idx+2]);
		data.push(d[idx+3]);
	}

	//console.log("data=", data, " ctr_x=",ctr_x);
	[xstart,  xend] = locateEdgesInLine(data, ctr_x, bwidth, swidth);
	data=[];
	for(var j= 0; j < sheight; j ++ ) {
		var idx = ((j * swidth) + ctr_x) * 4;
		data.push(d[idx+0]);
		data.push(d[idx+1]);
		data.push(d[idx+2]);
		data.push(d[idx+3]);
	}
	//console.log("data=", data, " ctr_y=",ctr_y);
	[ystart,  yend] = locateEdgesInLine(data, ctr_y, bheight, sheight);

	//console.log("CROSS: xo=",xstart+ctr_x, "y0=",ystart + ctr_y, "wid=",xend-xstart, "ht=",yend - ystart);
	return [xstart + ctr_x, ystart + ctr_y, xend - xstart , yend-ystart];
}


// used in ball pixel analysis, too much heuristics makes it data dependent
//
function locateEdgesInLine(data, center, box_width, swidth) {
	var idx, w_start, w_end, c_start, c_end, c_end2, ratio;
	var score, avg_last_score, avg_end_score, last_score, start_pix, end_pix;

	var ctr = center;
	var bwidth = box_width;
	var d = data;

	// [[r0, g0, b0, a0], [r1, g1, b1, a1]].....[r.w, g.w, b.w, a.w], ...
	w_start = Math.floor(ctr - (1 * bwidth));	// 3X window to detect edge
	w_end = Math.floor(ctr + (1 * bwidth));
	c_start = Math.floor(ctr - ((bwidth/2)));	// 1/2 window to sample ball
	c_end = Math.floor(ctr + ((bwidth/2))); 

	w_start = (w_start < 0) ? 0 : w_start;
	w_end = (w_end > swidth) ? swidth : w_end;
	c_start = (c_start < 0) ? 0 : c_start;
	c_end = (c_end > swidth) ? swidth : c_end;

	// color histogram design:
	//    - each color has 25 overlapping buckets (12 value each)
	//    - bucket centers - 10, 20, 30....250
	//    - bucket 20 range is [8, 33], 10=[-3, 23]
	//    - if value=28, it will be in bkt 20 & 30
	//    - a match increase the count, could be in 2 buckets
	const bkt_r=[];
	for(var j=0; j< 3; j++) {
		bkt_r[j] = [];
		for(var i=0; i< bkt_cnt; i++) {
			bkt_r[j][i] = 0;		// init histogram buckets
		}
	}

	//console.log("c_start=",c_start, " c_end=",c_end)
	var idx, b_idx, b_delta, val;
	for(var i=c_start; i<c_end; i++) {
		idx = i * 4;
		for(var j=0; j< 3; j++) {
			val = d[idx+j];
			b_idx = Math.floor(val / bkt_center);
			b_delta = val - (b_idx * bkt_center);
			bkt_r[j][b_idx] += 1;
			//console.log(val," ==> bump  [", b_idx, "] up  to ", bkt_r[j][b_idx])
			if(val < ((b_idx - 1) * bkt_center) + bkt_spread) {
				bkt_r[j][b_idx - 1] += 1;
				//console.log("         extra DOWN bump [", b_idx-1, "] up  to ", bkt_r[j][b_idx-1])
			} else if(val > ((b_idx + 1) * bkt_center) - bkt_spread) {
				bkt_r[j][b_idx + 1] += 1;
				//console.log("         extra UP bump [", b_idx+1, "] up  to ", bkt_r[j][b_idx+1])
			}
		}
	}

	//console.log("FINAL HISTOGRAM: ", bkt_r[0], bkt_r[1], bkt_r[2]);
	var max=[];
	max[0] = 0; max[1] = 0; max[2] = 0;
	for(var i=0; i<bkt_r[0].length; i++) {
		for(var j=0; j< 3; j++) {
			if(bkt_r[j][i]> max[j]) max[j] = bkt_r[j][i];
		}
	}
	//console.log("max=",max, " len=",bkt_r[0].length)
	for(var i=0; i<bkt_r[0].length; i++) {
		for(var j=0; j< 3; j++) {
			bkt_r[j][i]= Math.floor(bkt_r[j][i]/max[j] * 100);	// normalize to highest bkt
		}
	}
	//console.log("NORMALIZED HISTOGRAM: ", bkt_r[0], bkt_r[1], bkt_r[2]);

	// sample a horizontal line twice the ball width, find where ball starts
	start_pix = -1;
	end_pix = -1;
	//last_score = 100;
	//avg_last_score = 100000;		// seed
	avg_end_score = 10000;		// seed
	var steps, min_cnt, r=[], end_cnt = 0, end_candidate = -1;
	if(swidth > 600) {
		steps = Math.floor(swidth/200);		// coarse easier to detect features
		min_cnt = 2;
		c_end2 = Math.floor(ctr + ((bwidth/6))); 
	} else {
		steps = 1;
		min_cnt = 3;
		c_end2 = 20 + ctr;
	}
	//console.log("steps=", steps, " swidth=",swidth);
	for(var i=w_start; i<w_end; i += steps) {
		var idx = i * 4;
		score = 1;
		for(var j=0; j< 3; j++) {
			//r[j] = frame.data[idx + j];
			r[j] = data[idx + j];
			b_idx = Math.floor(r[j] / bkt_center);
			if(bkt_r[j][b_idx] > 80) {
				score = score * (1 + 12 * (bkt_r[j][b_idx] - 40));
			} else if(bkt_r[j][b_idx] > 60) {
				score = score * (1 + 6 * (bkt_r[j][b_idx] - 60));
			} else if(bkt_r[j][b_idx] > 30) {
				score = (score / 4) + 1;
			} else {
				score = (score / 8) + 1;
			}
		}

		// avoid immediate detection
		if(i == w_start) {
		    avg_last_score = score;
			last_score = score;
		}

		score = Math.floor(score);
		if(start_pix < 0) {
			ratio = ((score * 2)/(avg_last_score+last_score));
			// searching for begining of ball
			if((ratio > 60) && (score > 3500)) {
				start_pix =  i;
				//console.log("***** found start=", start_pix - ctr)
			} else if(i == ctr) {
				start_pix = Math.floor(ctr - (bwidth / 2));
				//console.log("***** default start=", start_pix - ctr)
			}
			//console.log("     idx=",  (i-ctr), " RGB(", r[0], ",", r[1], "," ,r[2], ")  ",
			//	"score=",score, " avg_score=",Math.floor(avg_last_score), " ratio=", Math.floor(ratio));
		} else if(end_pix < 0) {
			if (i >= w_end - steps){
				if(end_candidate < 0) {
					end_pix = Math.floor(ctr + (bwidth / 2));
				} else {
					end_pix = end_candidate;
				}
				//console.log("***** default end=", end_pix - ctr)
			} 

			if((i > c_end2) && ((avg_end_score/score) > 100)) {
				if((end_cnt == 0) || (avg_end_score > 100000)) {
					end_candidate = i;
					end_cnt = 1;
				} else {
					end_cnt += 1;	// do not reset
				}
			} else if (end_cnt > 0){
				// found a possible end, make sure the score is low for 10 pixels
				if(score < 2000) {
					end_cnt += 1;		// detect multiple low scores
					if(end_cnt > min_cnt) {
						end_pix =  end_candidate;
						//console.log("***** found end=", (end_pix - ctr))
						end_cnt = 1000;
					}
				} 
			} else {
				end_cnt = 0;		// reset, no conseq anymore
				end_candidate = -1;
			}

			//console.log("     idx=",  (i- ctr), " RGB(", r[0], ",", r[1], "," ,r[1], ")  score=",score, " avg_end_score=",Math.floor(avg_end_score), " ratio=", Math.floor(avg_end_score/score), "  chk=", (i>c_end2), "  end_cnt=",end_cnt);
		} else {
			//console.log("...  idx=",  (i- ctr), " RGB(", r[0], ",", r[1], "," ,r[1], ")  score=",score, " avg_end_score=",Math.floor(avg_end_score), " ratio=", Math.floor(avg_end_score/score), "  chk=", (i>c_end2));
		}

		last_score = score;
		avg_last_score = ((avg_last_score) + score ) / 2;
		avg_end_score = ((avg_end_score * 1) + (score * 3)) / 4;
	}

	var start = start_pix - ctr;
	var end = end_pix - ctr;
	//console.log("bwidth=",bwidth, " DETECT width=", (end - start));
	//console.log("w_start=", (w_start),"w_end=", (w_end), "c_end=", (c_end-ctr), "c_end2=", (c_end2-ctr));
	//console.log("start=", (start),"end=", (end));
	return [start, end];	
}



const MIN_POSEY_PCT_CHG_DELTA = 2;      // pct chg in Y before we adjust calib cone
const MIN_TRIPOD_Y_PCT = 75;            // if higher than this it's tripod, otherwize it's ont he group

 // Note: ***** NEED TO REDO WITH "PERSPECTIVE SLOPES"
 //
 function adjustCameraAngle() {
	var hidx = HISTORY.length - 1;

    // SWITCH CAMERA ANGLE: using full body bottom Y to determine the calibration Y
    //   - simpler than DY algo
    //
    var [ top, bot, ctr, samples ] = calcBodyY(hidx);      // extract from recent SLOPE[]
    var cam_mode = INFO.cam_ground_mode;
    INFO.has_full_body = true;
    //console.log("trail.892:       top=",top, " bot=",bot, " hidx=",hidx);
	if (((INFO.perf_mode === true) || (INFO.practice_mode === true)) && bot) {
        // if there is enough posn chg or diff mode then redo the cones
        //
        cam_mode = (bot > MIN_TRIPOD_Y_PCT) ?  "tripod" : "ground";
        if ((top < 1) || (bot > 99)) {
            //console.log("trail.853:    X X X X X X X X X X X X X NEED TO SEE FULL BODY!   X X X X X X X X X X X X X X X X X  top=",top, " bot=",bot);
            INFO.has_full_body = false;
            return;     // wait until we see the whole body
        }
        //console.log("trail.849:       . . .  CAMERA  ",hidx, ":   ctr=",ctr, "  bot=",bot, " samples=",samples, " pose_top=",INFO.pose_top, "  pose_bot=",INFO.pose_bot, "  cam_mode=",cam_mode);


        // move calibration cone closer to player if pose ctr has chg Y by >2%
        //    - this helps to adapt to diff camera angle
        //
        var obot = INFO.pose_bot;       // use mid point, more stable than top
        if (!INFO.pose_bot || (Math.abs(bot - obot) > MIN_POSEY_PCT_CHG_DELTA)) {
            //console.log("trail.858:       . . .  CAMERA  ",hidx, ":   top=",top, "  bot=",bot, " samples=",samples, " pose_top=",INFO.pose_top, "  pose_bot=",INFO.pose_bot, "  cam_mode=",cam_mode);
            INFO.pose_top = top;
            INFO.pose_bot = bot;
            INFO.pose_ctr = ctr;
            INFO.cam_ground_mode = cam_mode;        // change camer angle
            //console.log("trail.1129:       CAMERA  ",hidx, ":   top=",top, "  bot=",bot, " cam_mode=",cam_mode);
            if ((INFO.perf_running === false) && (INFO.has_calibration  === false) && (INFO.disable_calibration == false)) {
                console.log("anal_perf.1466:     ! ! ! ! ! ! ! ! !  SWITCH CAMERA MODE to ",INFO.cam_ground_mode, "  pose_top=",INFO.pose_top, " obot=",obot, "  bot=",bot," samples=",samples);
                initCONES("adjust_cam.1499");        // change detection if run has not started
            }
        }

        // DEBUG: camera angle ratio and player bottom %
        //
        if (INFO.override.show_ratio === true) {
            var btext = cam_mode + " " + bot;
            var color = 'red';
            var fsize = ((360 + 270) / 15) * INFO.scale_font;
            displayText(color, fsize, btext, 60, 100);
        }
    }
}





// PROCESS BODY REP EVENT
//    - for loop-based (skill): check turns
//    - for event-based (juke): check exit condition
//    - for cone-based (perf): check player location to cone
//
function processDrillReps() {
	var hidx = HISTORY.length - 1;
	var f0 = HISTORY[hidx];

	// Update Timer count
    //    - Either number of reps remaining
    //    - Or Timer count down (seconds)
    //    - M1137
	//
    var timer_mode = false;
    if ((INFO.practice_mode === true) && (INFO.practice_run_mode === "timer")) { timer_mode = true };
    if (INFO.defender_mode === true) { timer_mode = true };

	var color = "yellow";		// MORE VISIBLE
    var time_cnt1 = null;
    if (timer_mode === true) {
        if ((INFO.reps_running === true) && (TIMES.start_timer_run > 0)) {      // timer mode
            var tot = (INFO.timer_run_duration * 1000) + TIMES.start_timer_run;
            var secs = parseInt((tot - Date.now()) / 1000); 
            time_cnt1 = secs;
        } else {
            color = "";
            time_cnt1 = INFO.timer_run_duration;
        }
    }
    INFO.display_time_cnt = time_cnt1;
    INFO.display_rep_color = color;

	if (!f0 || (f0.pose.valid == false) || (f0.trail.pflip === false)) return;      // RETURN IF **** NO TURN *** DETECTED


    // process TURNS
    //
    var action = f0.action;
    var this_turn_time, finished = false;

    // practice mode:
    //    - immediately after a turn, look back and check if reached a undetected goal (due to femur error)
    //    - moved this here from analyzeBody() because we need to look at trail data
    //
    if ((INFO.practice_mode == true) && (INFO.reps_running == true)) {
        processPositionTurnVectors("pose", "drill_rep_prac.1514");		// OLD WAY: use position to count drill loops
        setFrameEvent("PTURN-"+(STATS.pose_turn_cnt -1)+"-"+hidx);

        var rep_cnt0 = calcPracticeRep();    // NOTE: Need to call this to detect turn, even for timer-based
        INFO.rep_run_cnt = INFO.rep_run_cnt + rep_cnt0;        // NEED THIS HERE?
        //INFO.drill_rep_cnt = INFO.drill_rep_cnt + rep_cnt;        // NEED THIS HERE?
        //INFO.drill_tot_rep_cnt = INFO.drill_tot_rep_cnt - rep_cnt;         do not chg tot_rep_cnt
        console.log("anal_perf.1525.xxx:   PTURN-",(STATS.pose_turn_cnt - 1), "  hidx=",hidx, "     x=",f0.trail.px,"        rep_run_cnt=",INFO.rep_run_cnt, " top_rep_cnt=",INFO.drill_tot_rep_cnt);     // use this to sync conslog with xls

        finished = ((INFO.rep_run_cnt + 1) > (INFO.drill_tot_rep_cnt - 1)) ? true : false;
        if (INFO.practice_run_mode === "reps") {
            // rep count mode:
            //
            //if (INFO.drill_tot_rep_cnt == 0) {
            if (INFO.rep_run_cnt == INFO.drill_tot_rep_cnt) {   // Note: replace drill_rep_cnt with rep_run_cnt?
                setFrameEvent("TIMING-STOP");	// DONE: for internal analysis
                //playAudio(CONSTS.SESSION_END_PATH, "reps_all_complete.1525");     // hard chime for finish one loop
                finishRun(finished);
            } else {
                //playAudio(CONSTS.REP_SUCCESSS_PATH, "reps_loop_complete.1527");     // not in a loop
            }
        } else {
            // timing mode:
            //
            var time = Date.now();
            if (time > (TIMES.start_timer_run + (INFO.timer_run_duration * 1000))) {
                setFrameEvent("TIMING-STOP");	// DONE: for internal analysis
                playAudio(CONSTS.REP_SUCCESSS_PATH, "reps_timeout.1535");     // hard chime for finish one loop
                finishRun(finished);
            }
        }
    }

    
    // defender mode:
    //     - check if beat the defender or timeout, which ends one rep
    //     - if all reps finished then end session
    // 
    else if ((INFO.defender_mode == true) && (INFO.defender_running == true)) {

        //var rep_cnt = calcPracticeRep();    // NOTE: Need to call this to detect turn, even for timer-based
        processPositionTurnVectors("pose", "drill_rep_defend.1556");		// OLD WAY: use position to count drill loops
        setFrameEvent("PTURN-"+(STATS.pose_sess_turn_cnt - 1)+"-"+hidx);

        var time = Date.now();
        var stop_time = TIMES.start_timer_run + (INFO.timer_run_duration * 1000);
        finished = ((INFO.rep_run_cnt + 1) > (INFO.drill_tot_rep_cnt - 1)) ? true : false;
        console.log("drill_reps.1521:   DEFENDER CHECK  @",hidx,"  rep_run_cnt=",INFO.rep_run_cnt, "  tot_rep=",INFO.drill_tot_rep_cnt, " finished=",finished, " gaveup=",action.gaveup, " timer_run_duration=",INFO.timer_run_duration," now_time=",(time % 100000), " start_time=", (TIMES.start_timer_run % 100000), " stop_time=",(stop_time % 100000));
        if (action.gaveup === true) {
            INFO.defender_running = false;
            if (finished === true) {
                //playAudio(CONSTS.SESSION_END_PATH, "defend_all_complete.1562");     // hard chime for finishing session
            } else {
                playAudio(CONSTS.REP_SUCCESSS_PATH, "defend_beat.1547");     // beat defender, success
            }
            setFrameEvent("GAVEUP-STOP-"+INFO.rep_run_cnt);	// DONE: for internal analysis
            finishRun(finished);
        }

        else if (time > stop_time) {
            INFO.defender_running = false;
            if (finished === true) {
                //playAudio(CONSTS.SESSION_END_PATH, "defend_all_complete.1571");     // hard chime for finish one loop
            } else{
                //playAudio(CONSTS.REP_FAIL_PATH, "defend_timeout.1573");     // Note: DO NOT DISTRACT PLAYER, timeout -failed
            }
            setFrameEvent("TIMING-STOP-"+INFO.rep_run_cnt);	// DONE: for internal analysis
            finishRun(finished);
        } 
        
        else {
            console.log("drill_reps.1544:             PTURN DETECTED @",hidx,"   turn_cnt=",STATS.pose_sess_turn_cnt, "  rep_run_cnt=",INFO.rep_run_cnt);
            //setFrameEvent("PTURN-"+STATS.pose_turn_cnt);	// DONE: for internal analysis


            // Note:   ! ! ! !   How to avoid reset this if defender is about to give up?


            //TIMES.start_run0 = TIMES.start_run;     // in case we need to use the last one
            //TIMES.start_run = Date.now();       // reset at each turn
        }
    }


    // perf mode:
    //     - Note: NEED TO VERIFY THE GOAL-CONE IS CORRECT!!!
    //
    else if ((INFO.perf_mode == true) && (INFO.perf_running == true)) {
        var reached_goal = recheckGoal();
        if (reached_goal > 0) {
            console.log("anal_perf.1133: =====>>>>  RECHECK GOAL SUCCESS!  @",hidx,"  goal=", reached_goal, " run_cnt=",INFO.rep_run_cnt);
            //var finished = (INFO.rep_run_cnt >= (CONSTS.PERF_RUN_COUNT - 1)) ? true : false;
            finished = (INFO.rep_run_cnt >= (INFO.drill_tot_rep_cnt - 1)) ? true : false;
            if (finished === true) {
                //playAudio(CONSTS.SESSION_END_PATH, "goals_all_complete.1596");     // hard chime for finish one loop
            }
            finishRun(finished);
        }
    }

    //console.log("trail.695:  NEW TARGET POSE BASE  pbx=", trail.pbasex, " pby=",trail.pbasey);
    this_turn_time = Math.floor(f0.timestamp);
    STATS.pose_turn_cnt = PTURNS.length - 1;         // STATS.pose_turn_cnt + 1;
    last_turn_time = this_turn_time;




    var run_cnt1 = (INFO.drill_tot_rep_cnt - INFO.rep_run_cnt);  // (CONSTS.PERF_RUN_COUNT - INFO.rep_run_cnt);
    INFO.display_rep_cnt = run_cnt1;
    console.log("trail.1673.xxx:    REPS COUNT  run_mode=",INFO.practice_run_mode, "  run_cnt1=", run_cnt1, " tot_rep=",INFO.drill_tot_rep_cnt, " rep_cnt=",INFO.rep_run_cnt);
}



// UTIL: Adaptive Expon Smoothing for Pose Speed
//     - This is critical for Change-of-Direction C01
//     - High sample rate need to smooth more to lower peaks
//     - Low sample rate need to take it raw to preserve peaks
//
// Note: Try step linear for now, do not be too reactive
//
function calcPoseSpeedExpon() {
    var expon =  null;
    var steps = parseInt(INFO.current_fps / CONSTS.EXPON_POSE_FPS_STEPS);

    switch (steps){
        case 0:     // 0 to 3
            expon = CONSTS.EXPON_POSE_BSPEED0;
            break;
        case 1:     // 3 to 6
            expon = CONSTS.EXPON_POSE_BSPEED1;
            break;
        case 2:     // 6 to 9
            expon = CONSTS.EXPON_POSE_BSPEED2;
            break;
        case 3:     // 9 to 12
            expon = CONSTS.EXPON_POSE_BSPEED3;
            break;
        case 4:     // 12 to 15
            expon = CONSTS.EXPON_POSE_BSPEED4;
            break;
        case 5:     // 15 to 18
            expon = CONSTS.EXPON_POSE_BSPEED5;
            break;
        case 6:     // 18 to 21
            expon = CONSTS.EXPON_POSE_BSPEED6;
            break;
        case 7:     // 21 to 24
            expon = CONSTS.EXPON_POSE_BSPEED7;
            break;
        case 8:     // 24 to 27
            expon = CONSTS.EXPON_POSE_BSPEED8;
            break;
        case 9:     // 27 to 30
            expon = CONSTS.EXPON_POSE_BSPEED9;
            break;
        default:     // 30+
            expon = CONSTS.EXPON_POSE_BSPEED9;
            break;
    }

    return expon;
}



const MIN_BODY_MOVE_PX = 2;     // min chg in px to determine dir chg

// extract useful body info into HISTORY
//var last_direction = 0;
function calcBodyMovement() {
	var f0=null, f1=null, f2=null, action=null, pose=null, dt = null;
	var hidx = HISTORY.length - 1, hidx1 = -1, hidx2 = -1;
	var speed, speed0, distpx, dir, degree, flip=false, last_degree = null;
	var x=null, y=null, ball_w=0, hip_w=0, px_ratio;

    if (INFO.has_calibration === false) { return [ -1, 0 ] };

	// find body velocity
	f0 = HISTORY[hidx];
	var stats = f0.stats;
	hidx1 = nextValidPoseFrame(hidx);   // prev frame
	if(hidx1 >= 0) {
		f1 = HISTORY[hidx1];
		//console.log("120:  got hidx1=",hidx1,"  f1=", f1)
		//hidx2 = nextValidBallFrame(hidx1 - 1);
		hidx2 = nextValidPoseFrame(hidx, CONSTS.MIN_SPEED_READ_MSEC);   // frame msecs away
		if(hidx2 >= 0) {
			f2 = HISTORY[hidx2];
			//console.log("123:  got hidx2=",hidx2," f2=", f2)
		}
	}

    // find last valid degree
    //
    last_degree = f0.action.body_degree;
    for (var h = (hidx1); h > 0; h--) {
        var f = HISTORY[h];
		var pose = f.pose
        var fdegree = f.action.body_degree;
		if ((pose.valid === true) && (fdegree >= 0)) {
            last_degree = fdegree;
            break;
        }
    }

	if(hidx2 >= 0) {
		// estimate speed using ball width as baseline conversion
		action = f0.action;
        pose = f0.pose;
        x = pose.ctr_x;
        y = pose.ctr_y;
        dt = f0.timestamp - f2.timestamp;

		//[ speed, distpx, dir, degree ] = calcMoveVector(stats, f0.pose.ctr_x, f1.pose.ctr_x, f0.pose.ctr_y, f1.pose.ctr_y, f0.timestamp, f1.timestamp);
		//console.log("530: Player dist_px =", distpx, " px_ratio=", px_ratio.toFixed(2), " distm=", distm)
		[ speed0, distpx, dir, degree ] = calcMoveVector(stats, pose.ctr_x, f2.pose.ctr_x, pose.ctr_y, f2.pose.ctr_y, f0.timestamp, f2.timestamp);

        //speed =  (CONSTS.EXPON_POSE_BSPEED * speed0) + ((1 - CONSTS.EXPON_POSE_BSPEED) * f1.action.body_speed);
        INFO.expon_pose_bspeed = calcPoseSpeedExpon();
        speed =  (INFO.expon_pose_bspeed * speed0) + ((1 - INFO.expon_pose_bspeed) * f1.action.body_speed);

		//console.log("536:            . . . Player SPEED   hidx=",hidx, " hidx1=",hidx1, " hidx2=",hidx2, " expon=",INFO.expon_pose_bspeed," s0=", speed.toFixed(2), " s1=",f1.action.body_speed.toFixed(2), " s2=",f2.action.body_speed.toFixed(2), " distpx=",distpx, 
        //"  degree=", degree, " dir=",dir, " spd0=",speed0.toFixed(2), " x0=",pose.ctr_x, " x1=",f1.pose.ctr_x, " x2=",f2.pose.ctr_x, " t0=",f0.timestamp%100000/1000, " t1=",f1.timestamp%100000/1000, " t2=",f2.timestamp%100000/1000);

		f0.action.body_dir = Math.floor(dir);
		f0.action.body_speed0 = speed0;		// speed in pixels
		f0.action.body_speed = speed;		// speed in pixels
		f0.action.body_dist = Math.floor(distpx);		// distance traveled in pixels
		f0.action.body_degree = Math.floor(degree);		// degree traveled 
        f0.action.body_flip = false;		// if change in body direction
        f0.action.defend_dx_ps = Math.abs((pose.ctr_x - f2.pose.ctr_x) / (dt / 1000));
        //console.log("1537:                     dx_ps=", f0.action.defend_dx_ps.toFixed(2), " f0.x=",pose.ctr_x, " f2.x=",f2.pose.ctr_x, " dt=",dt);

        INFO.pose_reverse = false;      // MEGA KLUDGE:  SHOULD NOT USE GLOBAL VAR THIS WAY
		if((distpx > MIN_BODY_MOVE_PX)) {
			// if significant movement then see if direction reversed
			// DIRECTION: 17=(+, +), 14=(+, 0), 9=(+, -), 8=(0, -), 7=(-, -), 13=(-, 0), 15=(-, +), 8=(0, -)
			//  17 v 7, 9 vs 15, 
			//var dir = calcDirection(f0.pose.ctr_x, f1.pose.ctr_x, f0.pose.ctr_y, f1.pose.ctr_y);
			//flip = determineDirectionChange(dir, last_direction);
			//console.log("           body dir = ", DIR[dir], "  dist_px=",distpx);
            flip = (Math.abs(degree - last_degree) > 130) ? true : false;
			if ((flip === true) && (degree >= 0) && (last_degree >= 0) && (f0.pose.valid === true) && (f2.action.body_flip === false)) {
				console.log("1526.xxx:                   ======>  BODY DIRECTION REVERSED.... hidx=",hidx, " x=",x, " y=",y,"  degree=", degree, "  last_degree=",last_degree, " dt=",parseInt(dt), " gesture=", INFO.gesture_allowed, " hide_calib=",INFO.disable_calibration);
                INFO.pose_reverse = true;
                f0.action.body_flip = true;		// if change in body direction
				//displayBodyReverse(DIR[dir], f0.pose.ctr_x, f0.pose.ctr_y);
			}
			//last_direction = f0.action.body_dir;
		}

		return [ speed, degree ];		// feet per second
	}
	return [ -1, 0 ];
}


// scan all recognized cones, add valid to CONES[] and remove flaky ones
//    - big part of this is to detect real cones and track movement
//
export function processCones() {
	var f0 = HISTORY[HISTORY.length -1];
	var CONE, dx, dy, dw, dh;
	var got_new = false, cone, keep_fake = true; 


    var fake_cones = 2;
    if(INFO.practice_mode == true) {
        fake_cones = 1;
    } else if (INFO.perf_mode == true) {
        fake_cones = (INFO.drill_param1.cones) ? INFO.drill_param1.cones : 2;    // for timer mode: in "real time sec" before kick
    } else {
        return;     // don't need cones
    }

    if(CONES.length < fake_cones) {
        //console.log("fakecones.1991        ! ! ! ! !   NEED MORE fake_cones=",fake_cones, " CONES.len=",CONES.length, " pose_bot=",INFO.pose_bot, " no_cone_cnt=",INFO.no_cone_cnt, " now=",Date.now()%100000/1000);
		//console.log("fakecones.1410:  seesion_name=", INFO.session_name, " fake_cones=",fake_cones, " no_cone=",INFO.no_cone_cnt, "  CONES.len=",CONES.length, " CONES=", CONES);
		setFakeCones(fake_cones);
	}
    if ((f0 === undefined) || (INFO.show_virtual_cones_only === true) || (INFO.perf_running == true)) { return; }


	var cones = f0.cones;	// grab from HISTORY

	//console.log("cone.1266:  PROCESS CONES START  cone.len=",cones.length, "  tot_cones=", INFO.fake_cones, " CONES.len=",CONES.length);
	// we have enough real cones, get rid of the fake ones
	//
	if(cones.length >= CONSTS.CONES_MIN_STARTING_CONES) {
		//console.log("cone.1296:  ALLOW FAKE CONE REMOVAL  cone.len=",cones.length, "  tot_cones=", INFO.fake_cones);
		keep_fake = false;
	}

	//if ((INFO.practice_mode == true) && (INFO.practice_mode == true)) 
	if (INFO.practice_mode == true) {
		cones = [];		// do not detect cones in practice mode
	}

	// f0.cones are detected by AI model, merge it into CONES which has fake cones (targets, home)
	for(var i = 0; i < cones.length + 1; i++) {
		//cone = (i == cones.length) ? CloneObject(OBJECT.ConeObj) : cones[i];		// last one is to flush out CONES only
		cone = (i == cones.length) ? CloneObject(ConeObj) : cones[i];		// last one is to flush out CONES only

		// go backwards so easier to get rid of bad ones
		got_new = true;
		for(var j = (CONES.length - 1); j >= 0; j--) {
			CONE = CONES[j];
			dx = Math.abs(CONE.ctr_x - cone.ctr_x);
			dy = Math.abs(CONE.ctr_y - cone.ctr_y);
			dw = Math.floor(Math.abs(CONE.width - cone.width));
			dh = Math.floor(Math.abs(CONE.height - cone.height));
			//console.log("cone.1133: ",j,"  CONE: cnt=", CONE.valid_cnt," vld=",CONE.valid, " dx=", dx, " dy=", dy," dh=", dh," dw=", dw);
			if ((dx < CONSTS.CONES_DETECT_DELTA_X) && (dy < CONSTS.CONES_DETECT_DELTA_Y) && 
				(dw < CONSTS.CONES_DETECT_DELTA_WIDTH) && (dh < CONSTS.CONES_DETECT_DELTA_HEIGHT)) {
				// got a match
				CONE.valid_cnt = (CONE.valid_cnt > CONSTS.CONES_MAX_POSITIVE) ? CONE.valid_cnt : CONE.valid_cnt + 1;		// cap it so it's easer to come back
				//console.log("cone.1141:  +++++++++++ CREDIT_CNT=>",j,"   i=",i, "   c.len=", cones.length,"  C.len=",CONES.length,  "  C.cnt=",CONE.valid_cnt, "  C.tmp=",CONE.tmp, " C.fake=",CONE.fake);
				if((CONE.valid_cnt > CONSTS.CONES_ACCEPT_THRESHOLD) && (CONE.valid == false)) {
					//console.log("cone.1136:  NEW VALID CONE: ", j, ".",CONE.id, "  cnt=", CONE.valid_cnt, " valid=", CONE.valid, " cone=", CONE);
					CONE.valid = true;
				}
				got_new = false;
			} else {
				CONE.tmp = CONE.tmp + 1;	// tmp counter to find totally unused
			}

			// maintain cone status, add new ones and remove old ones
			//
			if (i == (cones.length)) {
				// if there are enough cones then get rid of the fake ones
				var removable = true;
				if (CONE.fake == true) {
					if ((keep_fake == true) || (CONE.phantom == true)) {
						removable = false;
					}
				} 

				// check this once per round, trim down bad cones
				if (CONE.tmp > (cones.length)) {
					// did not match to any previous cones, may be a flake, remove it
					//console.log("cone.1132:  -------- DEBIT_CNT.",CONE.id,"=>",j," i=",i, " c.len=", cones.length, " C.len=",CONES.length, 
					//			" C.valid=", CONE.valid, " C.lcoked",CONE.locked,"  C.cnt=",CONE.valid_cnt, "  C.tmp=", CONE.tmp, " C.fake=",CONE.fake);
					CONE.valid_cnt = CONE.valid_cnt - 1;
					if ((CONE.locked == false) && (removable == true) && (INFO.perf_running == false)) {
						if ((CONE.valid == true) || (CONE.fake == true)) {
							// verified has to be valid, do not remove if sesison is running
							//console.log("cone.1335:  .........HERE.1   verfied=",CONE.verified, "  cnt=",CONE.valid_cnt);
							if (CONE.verified == true) {
								if (CONE.valid_cnt < -CONSTS.CONES_VERIFIED_REMOVE_THRESHOLD) {
									var removed=CONES.splice(j, 1);		// blue
									//console.log("cone.1139:  REMOVED VERIFIED.",CONE.id," ",j, "   ", removed, "  LEFT=",CONES);
								}
							} else {
								if (CONE.valid_cnt < -CONSTS.CONES_VALID_REMOVE_THRESHOLD) {
									var removed=CONES.splice(j, 1);		// green
									//console.log("cone.1148:  REMOVED VALID.",CONE.id," ",j, "   ", removed, "  LEFT=",CONES);
								}
							}
						} else {
							//console.log("cone.1347:  .........HERE.2   valid=",CONE.valid, "  cnt=",CONE.valid_cnt);
							if((CONE.valid == false) && (CONE.valid_cnt < -CONSTS.CONES_REGULAR_REMOVE_THRESHOLD)) {
								var removed=CONES.splice(j, 1);			// yellow
								//console.log("cone.1151:  REMOVED.",CONE.id," ",j, "   ", removed, "  LEFT=",CONES);
							}
						}

						if(CONES.length == 0) {
							INFO.no_cone_cnt = 40;		// give it a leg up
							INFO.cancel_cnt = 0;		// allow virtual cones to appear
							//console.log("cone.1130:  ------ ZERO CONES DETECTED! ");
						}
					} else {
						//console.log("cone.1362:  .........HERE.3   valid=",CONE.locked, "  fake=",CONE.fake, "  perf_run=",INFO.perf_running);
					}
				}
				CONE.tmp = 0;		// reset to 0 for next time
			}
		}

		if(got_new == true) {
			if(cone.prob > 20) {
				var ncone = {...cone};
				ncone.id = cone.ctr_x+"-"+cone.ctr_y+"-"+cone.height;		// hash for each find
				ncone.dy = 0;				// to calc when player is at the cone
				ncone.display = null;		// in use, can't be deleted
				ncone.locked = false;		// in use, can't be deleted
				ncone.fake = false;		// show person outline for calibration
				ncone.phantom = false;		// not just a marker
				ncone.home = false;			// not home cone
				ncone.show_person = 0;		// show person outline for calibration

				ncone.valid_cnt = 10;			// start with some so not eliminated right away
				ncone.valid = false;
				ncone.verified = false;		// player manually verified
				ncone.veri_cnt = 0;			// count to confirm verification
				ncone.tmp = 0;				// scratch pad var
				CONES.push(ncone);
				//console.log("cone.1153:  NEW CONE: ", j, "  cnt=", CONES.length, " cone=", ncone);
			}
		} 
		
	}

	// create virtual cones if player does not have any or enough cones
	//
	if(CONES.length >= CONSTS.CONES_MIN_STARTING_CONES) {
		INFO.no_cone_cnt = (INFO.no_cone_cnt < -CONSTS.CONES_MAX_NO_CONE_FRAME) ? INFO.no_cone_cnt : INFO.no_cone_cnt - 1;
	} else {
		INFO.no_cone_cnt = (INFO.no_cone_cnt > CONSTS.CONES_MAX_NO_CONE_FRAME) ? INFO.no_cone_cnt : INFO.no_cone_cnt + 1;
	}

	if(Math.abs(INFO.no_cone_cnt) !== CONSTS.CONES_MAX_NO_CONE_FRAME) {
		//console.log("cones.1300:  no_CONSTS.CONES_cnt =", INFO.no_cone_cnt, "  CONES.len=",CONES.length, " CONES=", CONES);
	}

    //console.log("fakecones.1967:        . . . no_cone_cnt=",INFO.no_cone_cnt, " CONES.len=",CONES.length);
	//if((INFO.no_cone_cnt > CONSTS.CONES_MAX_NO_CONE_FRAME) && (CONES.length < CONSTS.CONES_MIN_STARTING_CONES)) {
    //}
}


// POSTIONAL DETECTION (X-Y BASED - NOT USING LIMB MOTION VECTOR)
//    - KEY LOOP DETECTION ROUTINE - Call only when there is a turn
//    - Relies on RAW SIGNAL pose.trail.pflip
//    - look at degree and distance from last turn, use vectors to detect practice loop patterns.  
//    - For body loops, distill down to (delta-degree, delta-distance)
//
function processPositionTurnVectors(type, from) {
	var hidx = HISTORY.length - 1;
	var f0 = HISTORY[hidx];
	var ptidx = PTURNS.length - 1;
	var pt0 = PTURNS[ptidx];
	var btidx = BTURNS.length - 1;
	var bt0 = BTURNS[btidx];
	var dtime = -1, opdegree = -1, obdegree = -1, hidx0 = -1;

	switch (type) {
		case "pose":
			if (ptidx >= 0) {
				dtime = f0.timestamp - pt0.timestamp;
				opdegree = pt0.degree;
				hidx0 = pt0.hidx;
				//console.log("turnvec.1401:  last pose turn @",pt0.hidx, "  this turn @",hidx, "  f0.time=", f0.timestamp, " pt0.t=",pt0.timestamp);
			}
			break;
		case "ball":
			if (btidx >= 0) {
				dtime = f0.timestamp - bt0.timestamp;
				obdegree = bt0.degree;
				hidx0 = bt0.hidx;
				//console.log("turnvec.1405:  last ball turn @",bt0.hidx, "  this turn @",hidx, "  f0.time=", f0.timestamp, " bt0.t=",bt0.timestamp);
			}
			break;
	}


	// go through each frame since last turn to distill down data for this turn
    //     - need to filter out minor turns, happens often in a run
    //
	hidx0 = (hidx0 < 0) ? 0 : hidx0;    // from last PTURNS if avail
    var ptotdegree = 0;
    var btotdegree = 0;
    var ptotdist = 0;
    var btotdist = 0;
    var pcnt = 0;
    var bcnt = 0;
    var max_tspeed = 0;
    var min1_tdist = 99999;
    var min2_tdist = 99999;
    var max_timestamp = 0;
    var min1_timestamp = 0;
    var min2_timestamp = 0;
    var max_hidx = -1;
    var min1_hidx = -1;
    var min2_hidx = -1;
    var max_cnt = 0;
    var c_rate_up = null;
    var c_rate_down = null;
	var f1 = HISTORY[hidx0];        // from last turn

    var use_frame_average = true;
    if (use_frame_average === true) {
        // Note: Average the degrees of each frame to get true heading (better when read is inaccurate)
        //
		for(var i = hidx0; i < hidx; i++ ) {
			var f = HISTORY[i];
			var t = f.trail;
			if(t.pvalid == true) {
				ptotdegree = ptotdegree + t.pdegree;
				ptotdist = ptotdist + t.pdist;
				pcnt = pcnt + 1;
			}
			if(t.bvalid == true) {
				btotdegree = btotdegree + t.bdegree;
				btotdist = btotdist + t.bdist;
				bcnt = bcnt + 1;
			}
		}
        ptotdegree = ptotdegree / pcnt;
        ptotdist = ptotdist;    // / pcnt;
    } 

    const HIDX_EXPON_OFFSET = 0;      // not needed:  shift to account for expon smoothing delay
    const MAX_MIN_TSPEED_CLIMB_TIME = 300;     // min msec before we can get a max, this filters out slow walk
    const MIN_FRAME_TIME_DELTA = 90;     // min duration for it to be valid

    // For defender mode, figure out max velocity going in and coming out of the turn
    //     - min1 is the first low dist
    //     - min2 is always at the end (hidx), that is when next turn is detected (diff target X)
    //
    var find_peak_speed = true;
    if ((find_peak_speed === true) && (type === "pose")) {
        // Note: determine the most recent peak [ velocity, time ] during this turn segment
        //
        max_tspeed = 0;
        min1_tdist = 99999;
        min2_tdist = 99999;
        max_timestamp = -1;
        min1_timestamp = -1;
        min2_timestamp = -1;
        max_hidx = hidx;
        min1_hidx = -1;
        min2_hidx = -1;
        max_cnt = 0;
        var shidx = ((hidx0 - HIDX_EXPON_OFFSET) > 0) ? (hidx0 - HIDX_EXPON_OFFSET) : hidx0;       // shift back to catch true min
        var ehidx = hidx;
        var dincrease = false;  // distance increase
        var sincrease = false;  // speed increase
        var last_tdist = 999999, last_tspeed = 99999;
        console.log("turnvec.2020.xxx:  # # # # # # # # #   START MAX SPEED DETECT . . .  shidx=", shidx, "  hidx=",hidx, "   type=",type, " from=",from);
		for(var i = shidx; i <= ehidx; i++) {
            var f = HISTORY[i];
            var timestamp = f.timestamp;

            //var tspeed = f.trail.pspeed     // KLUDGE: pspd0: player speed, chg tspeed to pspeed when done
            //var tspeed = f.action.defend_speed     // a.dspd: player speed
            //var tspeed = f.action.defend_tspeed     // a.dtspd: player speed from the turn (dilutes)
            var tspeed = f.action.body_speed     // KLUDGE: pspd0: player speed, chg tspeed to pspeed when done
            var tdist = f.action.defend_tdist;        // a.ddist: distance from the turn

            //if ((tdist < min1_tdist) && (tdist >= 0) && (tspeed >= 0)) 
            if (i === shidx) {      // always take the first one
                min1_tdist = tdist;
                min1_timestamp = timestamp;
                min1_hidx = i;
                //console.log("turnvec.2048:         NEW MIN1  hidx=", i, "                                         min1_time=",(timestamp % 100000)/1000, " min1_tdist=",tdist);
            }

            if ((tspeed > max_tspeed)) {
                max_tspeed = tspeed;
                max_timestamp = timestamp;
                max_hidx = i;
                max_cnt = max_cnt + 1;
                //console.log("turnvec.2037:         NEW MAX   hidx=", i, "                                         max_time=",(timestamp % 100000)/1000, " max_tspeed=",tspeed.toFixed(2));
            }


            /* OLD: Don't need to be so fancy
            //
            if ((dincrease === false) && (tdist > last_tdist)) {
                dincrease = true;
            }

            if ((sincrease === false) && (tspeed > last_tspeed)) {
                sincrease = true;
            }

            tspeed = (tspeed) ? tspeed : -1;
            if ((tdist < min1_tdist) && (tdist >= 0) && (tspeed >= 0)) {
                min1_tdist = tdist;
                min1_timestamp = timestamp;
                min1_hidx = i;
                //console.log("turnvec.2048:         NEW MIN1  hidx=", i, "                                         min1_time=",(timestamp % 100000)/1000, " min1_tdist=",tdist);
            }

            if ((dincrease === true) && (sincrease === true) && (tspeed > max_tspeed)) {
                max_tspeed = tspeed;
                max_timestamp = timestamp;
                max_hidx = i;
                max_cnt = max_cnt + 1;
                console.log("turnvec.2037:         NEW MAX   hidx=", i, "                                         max_time=",(timestamp % 100000)/1000, " max_tspeed=",tspeed.toFixed(2));

                if (false && ((min1_hidx < 0) || ((min2_hidx > 0) && (min2_tdist < min1_tdist)))) {
                    // if new max then switch min2 to min1, by definition
                    //
                    min1_tdist = min2_tdist;       // reset after max
                    min1_timestamp = min2_timestamp;
                    min1_hidx = min2_hidx;
                    console.log("turnvec.2048:         NEW MIN1  hidx=", i, "                                         min1_time=",(min1_timestamp % 100000)/1000, " min1_tdist=",min1_tdist);

                    min2_tdist = 99999;       // reset after max
                    min2_timestamp = -1;
                    min2_hidx = -1;
                }
            }
            */

            last_tdist = tdist;     // detect an increase of tdist to get into this turn
            last_tspeed = tspeed;     // detect an increase of tspeed before detecting max, avoids slow walk
            //console.log("turnvec.2004:            . . .  hidx=", i, " time=",(timestamp % 100000)/1000, " tspeed=",tspeed.toFixed(2), "  tdist=",tdist, " max_tspeed=",max_tspeed.toFixed(3), " min1_hidx=",min1_hidx, " min2_hidx=",min2_hidx);
            //" min1_time=",(min1_timestamp%100000)/1000, " min2_time=",(min2_timestamp%100000)/1000);
        }

        //min2_tdist = tdist;        always at the end
        min2_timestamp = f0.timestamp;
        min2_hidx = hidx;
        //console.log("turnvec.2048:         NEW MIN2  hidx=", i, "                                         min2_time=",(f0.timestamp % 100000)/1000);    //, " min2_tdist=",tdist);

        var delta1 = max_timestamp - min1_timestamp;
        var delta2 = min2_timestamp - max_timestamp;
        c_rate_up = (delta1 > MIN_FRAME_TIME_DELTA) ? max_tspeed / ((delta1) / 1000) : 0;
        c_rate_down = (delta2 > MIN_FRAME_TIME_DELTA) ? max_tspeed / ((delta2) / 1000) : 0;   // Note: really need to account for expon smooth delay, maybe extract from the front end?
        console.log("turnvec.2050.xxx:   = = = = = FINAL PTURN.",PTURNS.length,"   hidx=", hidx, " c_rate_down=",c_rate_down.toFixed(3),  "  c_rate_up=",c_rate_up.toFixed(3), " min1_hidx=",min1_hidx, " max_hidx=",max_hidx, " min2_hidx=",min2_hidx);
        //" min1_time=",(min1_timestamp%100000)/1000, " min2_timestamp=",(min2_timestamp %100000)/1000, " max_time=",(max_timestamp %100000)/1000);
    }

    // recalc one shot ptotdegree from last PTURNS
    //     - chgs from last turn
    //
    var ptotdist1 = calcDistance(null, f0.trail.px, f1.trail.px, f0.trail.py, f1.trail.py);     
    var ptotdegree1 = calcDegree(null, f0.trail.pbasex, f1.trail.pbasex, f0.trail.pbasey, f1.trail.pbasey);
    //ptotdegree = calcDegree(stats, x1, basex, y1, basey);		// use base coord more stable
	console.log("turnvec.1447.xxx:          ADD PTURN.",PTURNS.length,":    . . . hidx=", hidx, " turn.hidx=",hidx0, "  x=",f0.trail.px, " x1=",f1.trail.px," @ptidx=",ptidx, " ptotdist=", ptotdist, " ptotdegree=",parseInt(ptotdegree), " ptotdist1=",ptotdist1," ptotdegree1=",ptotdegree1);

	var turn = {}
	turn.timestamp = f0.timestamp;		// msec of event
	turn.hidx = hidx;				// hidx of this turn
	switch (type) {
		case "pose":
			turn.type = "pose";				// "ball" or "pose"
			turn.dtime = dtime;				// delta msec from last turn
			turn.x = f0.trail.px;           // use the most current X
			turn.y = f0.trail.py;
			turn.degree = Math.floor(ptotdegree)    // / pcnt);
			turn.ddegree = Math.floor(turn.degree - opdegree);			// change in degree from last turn
			turn.dist = Math.floor(ptotdist)        // / pcnt);		// pix distance traveled since last turn
            turn.max_speed = max_tspeed;
            turn.max_timestamp = max_timestamp;
            turn.max_hidx = max_hidx;
            turn.c_rate_up = c_rate_up;
            turn.c_rate_down = c_rate_down;
			PTURNS.push(turn);      // always store, then quickly compress

            STATS.pose_sess_turn_cnt = STATS.pose_sess_turn_cnt + 1;
			//console.log("turnvec.1468:  PTURN=", JSON.stringify(turn));
			break;
		case "ball":
			turn.type = "ball";				// "ball" or "pose"
			turn.dtime = dtime;				// delta msec from last turn
			turn.x = f0.trail.bx;
			turn.y = f0.trail.by;
			turn.degree = Math.floor(btotdegree / bcnt);
			turn.ddegree = Math.floor(turn.degree - obdegree);			// change in degree from last turn
			turn.dist = Math.floor(btotdist / bcnt);		// pix distance traveled since last turn
			BTURNS.push(turn);
			//console.log("turnvec.1468:  BTURN=", JSON.stringify(turn));
			break;
	}

    if ((INFO.practice_mode === true) && (type === "pose")) {
        compressTurns();        // must do for loop detection
    }
}


// analyze body position
export function analyzeBody() {
    var hidx = HISTORY.length - 1;
	var fdata = HISTORY[hidx];

	if(HISTORY.length < 3) {
		return;
	}

	var [ speed, degree ] = calcBodyMovement();		// in femur per second
    if (INFO.override.show_ht === true) {
        displayBodyFTS(speed, degree);
    }
}



var last_touch_time = 0;	// determine touch-per-minute
var last_tpm = 0;
var last_turn_time = 0;		// determine turning speed for agility
var last_calc_time = 0;
var last_calc_cnt = 0;

// return a color that indicates speed
// src: https://www.bing.com/images/search?view=detailV2&ccid=JpWw%2F09w&id=14513B2D0C5A0F98EB0916810CD319043755547D&thid=OIP.JpWw_09wh1YclFDb4xDEngHaEh&mediaurl=https%3A%2F%2Fth.bing.com%2Fth%2Fid%2FR2695b0ff4f7087561c9450dbe310c49e%3Frik%3DfVRVNwQZ0wyBFg&riu=http%3A%2F%2Fwww.oracle.com%2Fwebfolder%2Fux%2Fmiddleware%2Frichclient%2Fguidelines5%2Fimages%2FinputColor%2FcolPalette121.png&ehk=rF1Ch%2FYDhh8EAltEtigZSJyRenvwHmMy%2BIh1M%2B3ns%2F8%3D&risl=&pid=ImgRaw&exph=523&expw=856&q=rgb+color+palette&simid=608012746063224366&ck=F085396BA1F0549A81AAB668007BC55A&selectedindex=9&form=EX0023&adlt=demote&shtp=GetUrl&shid=5bf88e69-11ad-4fce-9cbd-bfbf9500be96&shtk=RG9lcyBhbnlvbmUga25vdyB0aGUgUkdCIGNvZGUgZm9yIHRoZSBkaWZmZXJlbnQgY29sb3JzIG9mIGEgem93aWU%2FIDogTW91c2VSZXZpZXc%3D&shdk=Rm91bmQgb24gQmluZyBmcm9tIHd3dy5yZWRkaXQuY29t&shhk=T2rgPMSHRBWFb48kGxLeTi9jAROm3x%2FehgQvVy%2FSaK0%3D&shth=OSH.3IW%252B%252BzESkVpck718JxCIPA
const SPEED = [14, 13, 12, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0];
const COLOR = [ "(226,129,168", "(119,27,4", "(148,42,15", "(182,38,2", "(201,63,29", "(173,119,2", 
				"(230,157,0", "(227,18,77", "(250,199,90", "(250,232,91", "(161,212,51", 
				"(62,166,18", "(57,125,12", "(50,99,3"]

function trailColor(speed) {
	var color = "";
	var alpha = ",0.5)"
	for(var i = 0; i < SPEED.length; i++) {
		if(speed >= SPEED[i]) {
			return "rgba"+COLOR[i]+alpha;
		}
	}
}

// analyze ball position
export async function analyzeBall() {
	var x0, y0;  // ctr_x, ctr_y, this_touch_time, touch_delta, this_turn_time
	var pspeed, pdist, dir, degree, pose_trail = [], ball_trail = [];
	var x, y, x0, x1, y0, y1, speed, bcnt = 0, pcnt = 0;

	if(HISTORY.length < 3) { return; }
	var hidx = HISTORY.length - 1;
	var f0 = HISTORY[HISTORY.length - 1];
	var f1 = HISTORY[HISTORY.length - 2];
	var action = f0.action;
	var stats = f0.stats;
	var trail = f0.trail;
	var ball = f0.ball;


	//console.log("24:  frame wid=",width, " ht=",height, " ball=",ball);
	calcBallStats();		// go across prev frames

	[ pspeed, pdist, dir, degree ] = calcMoveVector(stats, f0.ball.ctr_x, f1.ball.ctr_x, f0.ball.ctr_y, f1.ball.ctr_y, f0.timestamp, f1.timestamp);
	action.ball_dir = Math.floor(dir);
	action.ball_speed = pspeed;
	action.ball_dist = Math.floor(pdist);
	action.ball_degree = Math.floor(degree);
	genBodyBallTrails();		// go across prev frames

	var bs = -1, ps = -1;
	bs = trail.bspeed;
	var rwidth =  CONSTS.BALL_SPEED_RIBBON_WIDTH;
	for(var i = hidx; i > 0; i--) {
		trail = HISTORY[i].trail;
		if(trail.bvalid !== null) {
			//console.log("trail.1029:  ",i,"   VALID  ", trail);
			x0 = trail.bx;
			y0 = trail.by;
			if(x1 > 0) {
				//console.log(i+":         ball  speed = ", speed, "  ratio=", stats.pixel_ratio, "   ");
				speed = (trail.bspeed == undefined) ? 0 : trail.bspeed;
				displaySpeedRibbon(trailColor(speed), rwidth, x0, y0, x1, y1);
				bcnt = bcnt + 1;
			}
			x1 = x0;
			y1 = y0;

			if(bcnt > CONSTS.TRAIL_LENGTH) {
				break;
			}
		} else {
			//console.log("trail.1051:  ",i,"  *** BAD ***  ", trail);
		}
	}

	x1 = -1; y1 = -1;
	ps = trail.pspeed;
	rwidth =  CONSTS.POSE_SPEED_RIBBON_WIDTH;
	for(var i = hidx; i > 0; i--) {
		trail = HISTORY[i].trail;
		if(trail.pvalid !== null) {
			x0 = trail.px;
			y0 = trail.py;
			if(x1 > 0) {
				speed = (trail.pspeed == undefined) ? 0 : trail.pspeed;
				//console.log(i+"         pose.ribbon  speed = ", speed.toFixed(1), " color=",trailColor(speed),"  x0=",x0, " y0=",y0, " x1=",x1, " y1=",y1);
				displaySpeedRibbon(trailColor(speed), x0, y0, x1, y1);
				pcnt = pcnt + 1;
			}
			x1 = x0;
			y1 = y0;

			if(pcnt > CONSTS.TRAIL_LENGTH) {
				break;
			}
		}
	}
	//console.log(hidx+ "         ball speed = "+ bs.toFixed(2)+ "   pose speed = "+ ps.toFixed(2));

	// DEBUG: draw ball label and bbox
	//
    var show_ball_stats = false;
    if (show_ball_stats) {
        var color = 'rgba(160,160,250,0.2)';		// for strokeRect
        const btext = "    FTS-"+pspeed.toFixed(2) + "-" + action.ball_degree;
        var font_size = (INFO.image_width + INFO.image_height)/90;
        displayText(color, font_size, btext, x, y);
        displayBox(color, 1, ball.x0, ball.y0+2, ball.bb_x, ball.bb_y);
    }

}



// MAIN: display overlay info on the image
//     - display cones
//     - display home zone
//     - display text annotations
//
export async function processAnnotation() {
	var x0, y0;  // ctr_x, ctr_y, this_touch_time, touch_delta, this_turn_time
	var x0, x1, y0, y1, speed, bcnt = 0, pcnt = 0;

	if(HISTORY.length < 3) { return; }

	var hidx = HISTORY.length - 1;
	var f0 = HISTORY[HISTORY.length - 1];
	var f1 = HISTORY[HISTORY.length - 2];
	var ball = f0.ball;
	var pose = f0.pose;
	var action = f0.action;
	var stats = f0.stats;
	var width = INFO.image_width;
	var height = INFO.image_height;
	var frame = null;
	//var cones = f0.cones;
	//var trail = f0.trail;

    //console.log("cones.802:      show_cones=",INFO.show_cones, "  disable_calib=", INFO.disable_calibration);
	if ((INFO.show_cones == true) && (INFO.disable_calibration == false)) {
		var ww = INFO.image_width;
		var hh = INFO.image_height;
		var ws = (ww > hh) ? 4 : 8;
		var hs = (ww > hh) ? 3 : 2;
		for(var i = 0; i < CONES.length; i++) {
			var cone = CONES[i];
			var target = false;
			var border = "rgba(255,255,255, 0)";		// no stroke

			if (cone.phantom == true) {
				//console.log("show.1724:  SKIP PHANTOM CONE:", cone.name);
				continue;			// don't show interim markers
			}

			if((INFO.perf_running == true) && (cone.display !== null) && (cone.display !== undefined)) {
				//console.log("show.1563:  BOARDER:", cone.name, " c.display=", cone.display, "  cone=", cone);
				switch(cone.display) {
					case "target":
						border = "rgba(0,255,0, 0.9)";		// target is always green
						target = true;
						break;
					case "success":
						border = "rgba(0,255,0, 0.3)";
						break;
					case "passing":
						border = "rgba(120,140,120, 0.3)";	// very light grey
						break;
					case "reverse":
						//border = "rgba(255,105,180, 0.8)";	 // purple (153,0,255, 0.8)
						border = "rgba(255,105,180, 0.3)";	 // purple (153,0,255, 0.8)
						break;
					case "false":
						border = "rgba(255,0,0, 0.3)";
						break;
				}
			}

			var ww2 = ww / 70 * calcYScale(cone.ctr_y, ww, hh);
			var hh2 = hh / 60 * calcYScale(cone.ctr_y, ww, hh);
			var cone_width = ww2 * ws * 1.5;
			var cone_height = hh2 * hs * 2;
			var cone_width2 = cone_width / 2;
			var cone_height2 = cone_height / 2;
			var x = cone.ctr_x - cone_width2;
			var y = cone.ctr_y - cone_height2;        // adjust for "ground view"
			var w = cone_width;
			var h = cone_height;
			var bw = CONSTS.CONES_STATUS_BORDER_PIXEL;

			// adjust cone color based on state
			//
			if(cone.target == true) {
                x = cone.ctr_x;
                y = cone.ctr_y;
				var tw = parseInt(CONSTS.FOOT_CALIB_SIZEX * INFO.scale_x);
				var th = parseInt(CONSTS.FOOT_CALIB_SIZEY * INFO.scale_y);
                var xx = parseInt(x - (tw / 2)); // - 10);
                var yy = parseInt(y + (th / 2)); // - 10);
				//displayEllipse(color, 0, x+(tw/2), y-(th/4), tw, th, 0, 0, Math.PI*2);     // show femur calibration spot

				//console.log("foot.2426:   - - - - -  SHOW CALIB ELLIPSE    xx=",xx, " yy=",yy, " tw=",tw, " th=",th, " canvas=",INFO.analysis_canvas);
				color = 'rgba(0,255,0, 0.9)';		// solid light green elipse, more visible in sunlight
                displayEllipse(color, color, 0, xx, yy, tw, th);
                //displayCenterDot(color, 1, xx, yy);

			} else if(cone.home !== true) {
                displayBlock(border, (x - bw), (y - bw), (w + (2*bw)), (h + (2*bw)));	// show border

				var fill = 'rgba(210,210,250, 0.3)';		// light grey, easier to see
				if (cone.valid == false) { 
					fill = 'rgba(210,210,210, 0.3)';		// light grey, easier to see
				} else {
					if ((cone.verified == true) || (cone.locked == true)) {
						if(INFO.perf_running == true) {
							//fill = 'rgba(0,0,250, 0.5)';		// deep blue when running
							fill = 'rgba(0,0,250, 0.1)';		// deep blue when running
						} else {
							//fill = 'rgba(180,180,0, 0.6)';		// light yellow, easier to see
							fill = 'rgba(180,180,0, 0.2)';		// light yellow, easier to see
						}
					} else {
						if (cone.veri_cnt > 0) {
							fill = 'rgba(0,220,240, 0.3)'; 		// aqua, being verified
						} else {
							//fill = 'rgba(180,180,0, 0.6)';		// light yellow, easier to see
							fill = 'rgba(180,180,0, 0.2)';		// light yellow, easier to see
						}
					}
				}
				if (cone.phantom == true) {
					fill = border;		// kludge: override
				}
				//console.log("show.1699:  fill=", fill, "  running=", INFO.perf_runing, " cone=",cone);
				color = (target == true) ? border : fill;
                displayBlock(color, x, y, w, h);
			}

			var show_cone_id = false;
			if(show_cone_id == true) {
				var color = 'red';
				const btext = cone.id;
				var font_size = (INFO.image_width + INFO.image_height) / 60;
				displayText(color, font_size, btext, x, y);
				//console.log("show.1699:  fill=", fill, "  running=", INFO.perf_runing, " cone=",cone);
			}
		}

		// if no calibration, constantly find the near and then far cone to do calibration
		// show a person_outline at a cone to instruct player calibration is needed
		if ((INFO.has_calibration == false) && (INFO.disable_calibration == false) && (INFO.calib_ww > 0)) {
            var c_ww = INFO.calib_ww;
            var c_hh = INFO.calib_hh;
            var c_xx = INFO.calib_xx;       // upper left
            var c_yy = INFO.calib_yy;       // upper left

            //console.log("draw.2481:     FOOTPRINT  foot=",INFO.footprint_shape, " xx=",c_xx, " yy=",c_yy,"  ww=", c_ww, "  hh=",c_hh, " scale_x=",INFO.scale_x, " cancel_cnt=",INFO.cancel_cnt);    //, " canvas=",INFO.out_context.canvas.canvas);
            displayImage(INFO.footprint_shape, 1, c_xx, c_yy, c_ww, c_hh);  // 379 x 287
		}
	}


	if ((INFO.show_home_zone == true) && (INFO.home_x > 0)) {
		//console.log("1591. show_home=",INFO.show_home_zone, "   home_x=",INFO.home_x);
		var stroke = null, border = null;
		var use_x = INFO.home_x;
		var use_y = INFO.home_y;
		var htw = INFO.home_xsize * INFO.scale_x;       // for display, but not center calc
		var hth = INFO.home_ysize * INFO.scale_y;

		var show_foot = false;
		if ((INFO.cancel_cnt > CONSTS.HOME_WARNING_THRESHOLD) && (INFO.perf_running == true)) {
			stroke = 'rgba(248,24,148,0.4)';		// staying at home - red -> cancelling
		} else {
			if (INFO.perf_running == false) {
				if (Date.now() > TIMES.timer_restart_cooldown) {
					show_foot = true;
					stroke = 'rgba(20,250,20,0.9)';		// not running - green -> come home
				} else {
					stroke ='rgba(100,150,100,0.3)';		// cool down period - green-grey
				}
			} else {
				if (INFO.target_idx == null) {
					show_foot = true;
					stroke ='rgba(20,250, 20, 0.9)';			// run, no goal - green -> come home    0.4
				} else {
					stroke ='rgba(100,100,100,0.3)';		// run, has goal - grey -> goto goal
				}
			}
		}

		var border = 'rgba(255,255,255,0)';
		var line = 0;
		if (INFO.perf_delay_mode == true) {
			border = 'rgba(236,254,240,0.95)';
			stroke = 'rgba(160,250,160,0.9)';		// not running - green -> come home
			line = 4;
		}

        var htw0 = CONSTS.FOOT_CALIB_SIZEX * INFO.scale_x * 1.1;		// do not scale x, makes it too fat
        var hth0 = CONSTS.FOOT_CALIB_SIZEY * INFO.scale_y * 1.3;        // 0.9
        var use_x1 = parseInt(use_x);
        var use_y1 = parseInt(use_y + (hth0 / 2));   // Note: Must use the foot dim

		displayEllipse(stroke, border, line, use_x1, use_y1, htw, hth);     // display home zone
		//displayCenterDot(stroke, 1, use_x, use_y);

		if(show_foot == true) {
			var hxx = use_x - (htw0 / 2);
			var hyy = use_y;
            //console.log("draw.2099:  >>>>>>>>>>>>>>>> HOME FOOT  htw0=", htw0, "  hth0=",hth0, " hxx=",hxx, " hyy=",hyy);
			displayImage(INFO.footprint_shape, 1, hxx, hyy, htw0, hth0);
		}
        //displayCenterDot(stroke, 1, INFO.home_x, INFO.home_y);
	}



    if (INFO.show_stats === false) { return };

    //////////////////////////////////////////////////////////////////////////////////////////////
    // DISPLAY HEADER INFO BELOW...

    //
    displayBlock(CONSTS.COLOR_STATS_BACKGROUND, 0, 0, 135, 15);       // background to make text show better
	displayFrameTimestamp(TIMES.current_frame);     // show current video time

    // show hidx and session ID at the corners
    //
    var hidx_y = 80;    // was 90
	var fsize1 = ((360 + 270) / 70) * INFO.scale_font;
    displayBlock(CONSTS.COLOR_STATS_BACKGROUND, 0, (hidx_y+5)+"%", 25, 15);       // background to make text show better
	displayText("#111", fsize1, hidx, 4, (hidx_y+9)+"%");     // SHOW HIDX @bottom_left

	var fsize2 = ((360 + 270) / 80) * INFO.scale_font;
    displayBlock(CONSTS.COLOR_STATS_BACKGROUND, "80%", "96%", "20%", "4%");       // background to make text show better
	displayText("#333", fsize2, TIMES.session_start, "82%", "99%");     // SHOW HIDX @bottom_left

    // show reps left in the drill
    //
	displayRepsLeft(INFO.display_rep_cnt, INFO.display_time_cnt, INFO.display_rep_color);
    displayNotification();     // display INFO.notify_messages[],  replaces displayFrameTimestamp()



    //////////////////////////////////////////////////////////////////////////////////////////////
    // DEBUG DISPLAYS BELOW

    // DEBUG: display head position
    //
	var show_facing = true
    var sigs = pose.signals;
	if ((show_facing === true) && (sigs !== null)) {
        var out = "";
        if (sigs.look_down === true) { out = out + "DOWN-"+INFO.heads_up_frames; }
        if (sigs.look_right === true) { out = out + " RGT"; }
        if (sigs.look_left === true) { out = out + " LFT"; }
        //displayFacing(out);       // DISABLE FOR NOW
    }


	// DEBUG: show 6 feet calibration bar for distance calibration
	//
	if(INFO.show_calibration_mark) {
		const six_feet = calcFeet2Pixel(stats.pixel_ratio, 6);
		color = 'rgba(240,0,0, 0.3)';		// for strokeRect
		displayLengthCalibration(six_feet, color, pose.ctr_x, pose.bottom);
    }

    // DEBUG: show extended arm bar for distance calibration
    //
    if (INFO.override.show_ht === true) {
        var fmr_ft = calcPixel2Feet(STATS.pixel_ratio, INFO.ref_femur);
        var ht_ft = fmr_ft / CONSTS.FEMUR_BODY_RATIO;   // female 25.0%, male 25.7%
        var ht_px = calcFeet2Pixel(STATS.pixel_ratio, ht_ft);
        var ctr_x = f0.pose.ctr_x;
        var sho_y = f0.pose.sho_y + 20;
        INFO.height_inch = parseInt(ht_ft * 12);
        displayCalibrationBar(ht_px, ctr_x, sho_y);
	}

	// DEBUG: display grid line for each eyeballing
	//
    if(INFO.override.show_grid === true) {
        //console.log("show_ball.1837: ENABLE GRID LINE DISPLAY");
        displayGridLines();
        displayBox("red", 1, "30%", INFO.pose_bot+"%", 20, 3);   // DEBUG:  POSE BOTTOM MARKER ALIGNMENT
    }


    // DEBUG: analyze the image pixels to get confirmation of the ball size
    //     - this relies on lots of heuristics, needs more work
	var show_pixel_extracted_ball = false
	if(show_pixel_extracted_ball === true) {
		frame = INFO.context.getImageData(0, 0, width, height);	// grab pixels for analysis
		displayCenterDot("red", 1, ball.ctr_x, ball.ctr_y);

		// extract more accurate ball size from pixel, not working that well yet
		[x0, y0, ww, hh]= extractBallFromPixels(frame, width, height);
		displayExtractedBallBox("red", 2, x0, y0, ww, hh);
	}


    // DEBUG: 3D ANALYSIS DEV
    //
    var sigs = pose.signals;
	if ((INFO.drill_param1.show_degrees) && (sigs !== null)) {
        var out = "";
        if (sigs.larm) {
            displayDegrees(0, "LARM  dgr="+sigs.larm.degree+" X="+sigs.larm.xd+" Y="+sigs.larm.yd+" Z="+sigs.larm.zd);
            displayDegrees(1, "LFAM  dgr="+sigs.lfam.degree+" X="+sigs.lfam.xd+" Y="+sigs.lfam.yd+" Z="+sigs.lfam.zd);
            displayDegrees(2, "RARM  dgr="+sigs.rarm.degree+" X="+sigs.rarm.xd+" Y="+sigs.rarm.yd+" Z="+sigs.rarm.zd);
            displayDegrees(3, "RFAM  dgr="+sigs.rfam.degree+" X="+sigs.rfam.xd+" Y="+sigs.rfam.yd+" Z="+sigs.rfam.zd);

            displayDegrees(4, "LTHG  dgr="+sigs.lthg.degree+" X="+sigs.lthg.xd+" Y="+sigs.lthg.yd+" Z="+sigs.lthg.zd);
            displayDegrees(5, "LLEG  dgr="+sigs.lleg.degree+" X="+sigs.lleg.xd+" Y="+sigs.lleg.yd+" Z="+sigs.lleg.zd);
            displayDegrees(6, "RTHG  dgr="+sigs.rthg.degree+" X="+sigs.rthg.xd+" Y="+sigs.rthg.yd+" Z="+sigs.rthg.zd);
            displayDegrees(7, "RLEG  dgr="+sigs.rleg.degree+" X="+sigs.rleg.xd+" Y="+sigs.rleg.yd+" Z="+sigs.rleg.zd);

            displayDegrees(8, "CHED  dgr="+sigs.ched.degree+" X="+sigs.ched.xd+" Y="+sigs.ched.yd+" Z="+sigs.ched.zd);
        }
    }

    // DEBUG: misc display
    //
    var show_extra_info = false;
    if (show_extra_info) {
        displayTPM(last_tpm);		// show ball touch per minute
        displayCenterDot("blue", 1, ball.ctr_x, ball.ctr_y); 	// show ball dot
        displayCenterDot("blue", 1, pose.ctr_x, pose.ctr_y); 	// show player dot

        displayFilename("YOLO: "+INFO.file_name.toUpperCase());
        displayStars(INFO.drill_stars, Star_shape);     // show how well the player did on the last rep
    }


    // DEBUG: for developer tools
    //
    var show_dev_stuff = false;
    if (show_dev_stuff) {
        displayEllipse("red", "red", 0, "50%", "70%", 6, 6);      // DEBUG: CENTER CALIBRATION
    }

    
	/////////////////////////////////////////////////// end of screen annotation /////////////////////////////////////////////////////////////////
}





// go through all videos in the list, determine % of frames
// without a ball, take a snapshot so it can be annotated and trained
//
async function collectBallStatistics(paths) {
	var play_speed = 3;
	console.log("942: list=", paths);

	setupVideoFile(null, play_speed, paths);   // willl do auto read from video
}


export function batchAnalysis(task, paths) {
	switch (task) {
	    case 'videos':
			// go through all video files in the list
			collectBallStatistics(paths);
		    break;
	    case 'images':
		    break;
	}

}


const person_path = "images/person_shape.png"
const footprint_path = "images/footprint.png"
const star_path = "images/star75.png"
var Person_shape=null;
var Star_shape=null;
//var INFO.footprint_shape=null;
export async function initAnalyzer() {
	//last_touch_time = performance.now();
	last_touch_time = Date.now();

	initTables();
	initHistory();

	// initialize global cumulative stats
	for (var prop in STATS) {
		if(Object.prototype.hasOwnProperty.call(STATS, prop)) {
			//console.log("    clearing ", prop, "  ",STATS[prop]);
			STATS[prop] = 0;
		}
    }

	// setup display modes
	if (INFO.analysis_canvas == "output") {
		var y_canvas = document.getElementById('yolo');
		if(y_canvas !== null) {
			y_canvas.style.display = "none";
		}
	}

    Person_shape = await loadImage(person_path);
    INFO.footprint_shape = await loadImage(footprint_path);
    Star_shape = await loadImage(star_path);        //"../assets/image/star.png");

	console.log("analyzer.1340: AI Analyser State INITIALIZED...", STATS.tot_frames);
	//console.log("analyzer.1999: XXXXXXXXXXXXXXXXXXXXXXXXXXXXX OBJECT_CLASS=",  ConeObj);
}



// before APS, we used the debug out put here to support data analysis
//
export async function closeAnalyzer() {
	var hidx = HISTORY.length - 1;
	var dump_movement = true;
	var dump_femur_y = false;
	var dump_slope_hist = false;

	if(guiState.dump_log == true) {
		// dump out pose and ball movement raw data
		//
		if(dump_movement == true) {
			var start = (hidx > 1000) ? (hidx - 500) : 0;
			console.log(",*** DUMPING MOVEMENT DATA ");
			console.log(",", INFO.file_name);
			console.log(",hidx,time,"+
						 "ball.valid, bx,by,bdist,bspeed,bdegree,bflip,"+
						"pose.valid, px,py,pdist,pspeed,pdegree,pflip,"+
						"bdegree0,DT,bbx,bby,bbby,ppby,"+
						"pdegree0,bspeed0,pspeed0,");
			for (var i = start;  i < hidx; i++) {
				var f0 = HISTORY[i];
				var t = f0.trail;
				var b = f0.ball;
				var p = f0.pose;
				if((t.bspeed >= 0) && (t.pspeed >= 0)) {
					console.log(","+i+","+Math.floor(f0.timestamp)+","+t.bvalid+","+t.bx+","+t.by+","+t.bdist+","+t.bspeed.toFixed(3)+","+t.bdegree+
								","+ t.bflip+","+t.pvalid+","+t.px+","+t.py+","+t.pdist+","+t.pspeed.toFixed(3)+","+t.pdegree+","+t.bflip+
								","+ t.bdegree0+",," +b.ctr_x+"," +b.ctr_y+"," +"  ," +b.ctr_by+"," +p.ctr_by+","+t.pdegree0+","+t.bspeed0+","+t.pspeed0+",");
					//console.log("1271."+(i)+":  BALL "+t.bvalid+"   x="+t.bx+"  y="+t.by+"  dist="+t.bdist+"  spd="+t.bspeed.toFixed(3)+"  dir="+t.bdegree+
					//						"   POSE "+t.pvalid+"   x="+t.px+"  y="+t.py+"  dist="+t.pdist+"  spd="+t.pspeed.toFixed(3)+"  dir="+t.pdegree);

				} else {
					console.log(i+" ******** BAD SPEED ******* ", t);
				}
			}
		}

		// dump out femur length stats
		//
		if(dump_femur_y == true) {
			var output="";
			console.log(",*** DUMPING FEMUR CORRELATION DATA ");
			console.log(",", INFO.file_name);
			console.log(",idx,femur");
			for (var i = 0;  i < FEMUR.length; i++) {
				var femur = FEMUR[i];
				output = ","+i.toString()+",";
				if(femur.length > 0) {
					for (var j = 0;  j < femur.length; j++) {
						output = output +femur[j].toString()+",";
					}
					console.log(output);
				}
			}
		}

		// dump out femur-v-Y slope data
		//
		if(dump_slope_hist == true) {
			var output="";
			var max = -1;
			var max_i = -1;
			var tot_mcnt = 0;
			for (var i = 0;  i < SHIST.length - 1; i++) {
				var slope = SHIST[i];
				//console.log("     ",i, "  ",slope.length, "   max=",max_i);
				tot_mcnt = tot_mcnt + slope.length;
				if(slope.length > max) {
					max = slope.length;
					max_i = i;
				}
			}

			// print out the biggest bucket
			console.log(",*** DUMPING SLOPE DATA   tot_m=",tot_mcnt, "   i=",max_i, " MAX=",max, " femur_bucket_size=",INFO.femur_bucket_size);
			console.log(",", INFO.file_name);
			console.log(",indx, bkt, y, femur_px, dy, df, slope");
			var slope = SHIST[max_i];
			for (var j = 0;  j < slope.length; j++) {
			//for (var j = 0;  j < 200; j++) {}		// FOR AUDIT ONLY
				var s = SHIST[max_i][j];
				if(s !== undefined) {
					console.log(",", j, ",", max_i, ",", s.y,",", s.f, ",", s.dy,",", s.df, ",", (s.m).toFixed(3),",");
				}
			}
		}

	}
	console.log("stopVideo.371:  Video ENDED!   STATS=",JSON.stringify(STATS), "  tf.mem=", tf.memory());
	console.log("stopVideo.1273:  ",guiState);
}